/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { TestQConfig } from '../../../../model/testQConfig';
import { TestQType, TestTypeEnum } from '../../../../model/testQType';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { TestQElementType } from '../../../../model/testQElementType';
import { VerificationQType } from '../../../../model/verificationQType';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ExpectedResultType } from 'src/app/model/expectedResultType';
import { ResultQType } from '../../../../model/resultQType';
import { SnackBarService } from '../../../../services/snackBar.service';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/services/user.service';
import { ReasonDialogComponent } from 'src/app/components/shared/reason-dialog/reason-dialog.component';
import { MatSelectChange } from '@angular/material/select';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as _ from 'lodash';
import { AttachmentQualificatesService } from '../../../../services/attachmentQualificates.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ExecutionQTest, ExecutionQTestData, ExecutionQTestDeviationData, ExecutionStatus } from 'src/app/model/execution';
import { ExecutionEditTestAttachmentsComponent } from '../execution-edit-test-attachments/execution-q-edit-test-attachments.component';
import { EquipmentAutocompleteFilter } from '../../../../model/autocompleteFilter';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { DateTime } from 'luxon';

import { ExecutionEditQDeviationComponent } from '../execution-edit-q-deviation/execution-edit-q-deviation.component';
import { ExecutionQTestDeviations, ExecutionQTestItemGroup, ExecutionQTestEssayGroup, ExecutionQTestEssay, ExecutionQTestDataObservations, ExecutionQTestInstrumentalUsed, ExecutionQTestCriticalInstrumentation, TestTypeDeviations, ExecutionQ, ExecutionQTestDataOQ } from '../../../../model/execution';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Sensor } from '../../../../model/sensor';
import { VariableTypeEnum, VariableUnit, VariableUnitEnum } from '../../../../model/variable';
import { VariableTypeService } from '../../../../services/variableType.service';
import { Field } from '../../../../model/field';
import { FieldEnum, FieldUtils } from '../../../../utils/fieldUtils';
import { ExecutionQEditEssayFieldComponent } from '../execution-q-edit-essay-field/execution-q-edit-essay-field.component';
import { EssayTypeEnum, EssayUtils, HotColdValueEssay, LethalityValueEssay, MinMaxValueEssay } from '../../../../utils/essayUtils';
import { Criteria } from '../../../../model/criteria';
import { ExecutionQEditDialogCorrectSensorComponent } from '../execution-q-edit-dialog-correct-sensor/execution-q-edit-dialog-correct-sensor.component';
import { ExecutionUtils } from '../../../../utils/executionUtils';
import { ExecutionQEditAttachmentDetailsComponent } from '../execution-q-edit-attachment-details/execution-q-edit-attachment-details.component';
import { DateUtils } from '../../../../utils/dateUtils';
import { ArrayUtils } from '../../../../utils/arrayUtils';
import { PhotoUtils } from '../../../../utils/photoUtils';
import { NgxImageCompressService } from 'ngx-image-compress';
import { SensorData } from '../../../../model/sensorData';
import { ExcelUtils } from '../../../../utils/excelUtils';
import { EventEssayVariableKeys } from '../../../../model/protocol';
import { ExecutionQEditBioindicatorsDetailsComponent } from '../execution-q-edit-bioindicators-details/execution-q-edit-bioindicators-details.component';
import { BioindicatorConfig } from '../../../../model/bioindicator';
import { ExecutionQEditReasonExpositionTimeComponent } from '../execution-q-edit-reason-exposition-time/execution-q-edit-reason-exposition-time.component';
import { ExecutionQEditGraphComponent } from '../execution-q-edit-graph/execution-q-edit-graph.component';
import { ExecutionQEditEssayBottomSheetUploadComponent } from '../execution-q-edit-essay-bottom-sheet-upload/execution-q-edit-essay-bottom-sheet-upload.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DialogDataCopyEssayResult, ExecutionQEditCopyEssayComponent } from '../execution-q-edit-copy-essay/execution-q-edit-copy-essay.component';
import { ExecutionQTestsService } from '../../../../services/execution-q-tests.service';
import { ExecutionQTestEssayService } from '../../../../services/executionQTestEssay.service';
import { SensorUtils } from '../../../../utils/sensorUtils';
import { ExecutionQTestDefrostService } from '../../../../services/executionQTestDefrost.service';
import { Defrost } from '../../../../model/defrost';
import { ExecutionQTestDataMultipleService } from '../../../../services/executionQTestDataMultiple.service';
import { ExecutionEditQTestObservationsComponent } from '../execution-edit-q-test-observations/execution-edit-q-test-observations.component';
import { ExecutionQTestDataObservationsService } from '../../../../services/executionQTestDataObservations.service';
import { ExecutionQEditConfigSensorComponent } from '../execution-q-edit-config-sensor/execution-q-edit-config-sensor.component';
import { ExecutionQEditDefrostListComponent } from '../execution-q-edit-defrost-list/execution-q-edit-defrost-list.component';
import { ExecutionQEditTestInstrumentalUsedComponent } from '../execution-q-edit-test-instrumental-used/execution-q-edit-test-instrumental-used.component';
import { ExecutionQEditTestCriticalInstrumentationComponent } from '../execution-q-edit-test-critical-instrumentation/execution-q-edit-test-critical-instrumentation.component';
import { AttachmentType } from '../../../../model/attachment';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { ExecutionQTestEssayGroupService } from 'src/app/services/executionQTestEssayGroup.service';
import { ExecutionQTestCriticalInstrumentationService } from 'src/app/services/executionQTestCriticalInstrumental.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { v4 as uuid } from 'uuid';
import { ExecutionEditQDeviationListComponent } from '../execution-edit-q-deviation-list/execution-edit-q-deviation-list.component';
import { ExecutionQTestDataOQService } from '../../../../services/executionQTestDataOQ.service';
import { Essay } from 'src/app/model/essay';
import { EquipmentTypeQualificationEnum } from '../../../../model/equipmentType';
import { StringUtils } from '../../../../utils/stringUtils';
import { VerificationProcessingTypeEnum } from '../../../../model/testQDataVerification';
import { ProtocolUtils } from '../../../../utils/protocolUtils';
import { ExecutionQDeviationService } from '../../../../services/executionQTestDeviation.service';
import { QualificationUtils } from '../../../../utils/qualificationUtils';
import { EquipmentPerformances } from '../../../../utils/equipmentUtils';

export class Group {
	level = 0;
	expanded = false;
	totalCounts = 0;
}

export interface DialogQEditTest {
	idItem: number;
	testQType: TestQType;
	reason: string;
	isEdit: boolean;
	isEditTest: boolean;
	data: ExecutionQTest;
	idStatus: number;
	numberTest: number;
	protocolNumber: string;
	notSelectedTest: boolean;
	tests: ExecutionQTest[];
	deviations: ExecutionQTestDeviations[];
	ex: ExecutionQ
}
export interface DialogDataDeviationList {
	data: ExecutionQTestDeviationData;
}
@Component({
	selector: 'app-execution-q-edit-test',
	templateUrl: './execution-q-edit-test.component.html',
	styleUrls: ['./execution-q-edit-test.component.scss'],
	standalone: false,
})
export class ExecutionQEditTestComponent implements OnInit, AfterViewInit {

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild('tableTest', { static: true }) tableTest: MatTable<any>;
	@ViewChild('attachmentsTestComponent') attachmentsComponent: ExecutionEditTestAttachmentsComponent;
	@ViewChild('graph') graph: ExecutionQEditGraphComponent;
	@ViewChild('executionQTestInstrumentalUsedTable', { static: true }) executionQTestInstrumentalUsedTable: MatTable<any>;
	@ViewChildren('criticalInstrTable') criticalInstrTable: MatTable<any>;
	@ViewChild('autosizeVerification') autosize: CdkTextareaAutosize;
	@ViewChild('obsTestTable') obsTestTable: MatTable<any>;
	@ViewChild('devTable') devTable: MatTable<any>;

	@Output() fcStartEssayEmitter = new EventEmitter<any>();
	@Output() updateSensorEssayEmitter = new EventEmitter<any>();
	@Output() updateAttachmentListEmitter = new EventEmitter<any>();
	@Output() onIdPeakEmitter = new EventEmitter<any>();
	@Output() reloadPageEmitter = new EventEmitter<any>();
	@Output() essayActiveEmitter = new EventEmitter<any>();
	@Output() essayActiveReasonEmitter = new EventEmitter<any>();

	allData: any[];
	_allGroup: any[];
	dataSource: ExecutionQTest = new ExecutionQTest();

	displayedColumns: string[] = ['verificationTypeDesc'];
	displayedColsObservations: string[] = ['position', 'description', 'edit', 'delete'];
	displayedColsInstrumentalUsed: string[] = ['instrumental', 'edit', 'delete'];
	displayedColsDeviations: string[] = ['code', 'valuation', 'resolved', 'modDate', 'modUser', 'edit'];

	public displayedColsCriteria = ['criteria'];
	criticalInstrumentalCols = ['equipment', 'internalId'];
	resultCritical = ['according', 'not_according', 'not_applicable'];

	columnsToDisplay: string[] = this.displayedColumns.slice();
	groupByColumns: string[] = [];

	testConfig: TestQConfig = new TestQConfig();
	testQTypes: TestQType[];
	testQElementTypes: TestQElementType[];
	verificationQTypes: VerificationQType[];
	expectedResultTypes: ExpectedResultType[];
	resultQTypes: ResultQType[];
	columns: any[] = [];
	expandedCar: any[] = [];
	fileName: string | null = null;

	currentUser: User;
	_groupItem = 0;
	_essayIndex = 0;
	_variableIndex = 0;

	variableUnits: VariableUnit[];

	public equipmentName: string;

	public equipmentAutoComplete: Map<number, InternalEquipment[]>;
	graphMap = new Map<string, SensorData[]>();
	copyGraphDateMap = new Map<EventEssayVariableKeys, boolean>();

	customDatepickerHeader = CustomDatepickerHeaderComponent;

	quillConfig = {
		toolbar: [
			['bold', 'italic', 'underline'],
			[{ list: 'ordered' }, { list: 'bullet' }]
		]
	};
	selectedOption: string[] = [];
	isTacometer: boolean;
	tacometer: string;

	itemGroupReserve: ExecutionQTestItemGroup[];

	private destroy$ = new Subject<void>();

	constructor(private cd: ChangeDetectorRef,
		private snackBarService: SnackBarService,
		private executionQTestEssayService: ExecutionQTestEssayService,
		private executionQTestEssayGroupService: ExecutionQTestEssayGroupService,
		private executionQTestService: ExecutionQTestsService,
		private bottomSheet: MatBottomSheet,
		private dialogRef: MatDialogRef<ExecutionQEditTestComponent>,
		private translate: TranslateService,
		private userService: UserService,
		private attachmentService: AttachmentQualificatesService,
		private spinnerService: SpinnerService,
		private internalEquipmentService: InternalEquipmentService,
		private variableTypeService: VariableTypeService,
		public dialog: MatDialog,
		private imageCompress: NgxImageCompressService,
		private defrostService: ExecutionQTestDefrostService,
		private executionQTestDataMultipleService: ExecutionQTestDataMultipleService,
		private executionQTestDataObservationsService: ExecutionQTestDataObservationsService,
		private executionQTestCriticalInstrumentationService: ExecutionQTestCriticalInstrumentationService,
		private executionQTestDataOQService: ExecutionQTestDataOQService,
		private deviationService: ExecutionQDeviationService,
		@Inject(MAT_DIALOG_DATA) public data: DialogQEditTest,
		@Inject(MAT_DIALOG_DATA) public dataList: DialogDataDeviationList) {
		this.currentUser = this.userService.currentProfile;

	}

	ngOnInit(): void {
		this.equipmentAutoComplete = new Map<number, InternalEquipment[]>();
		if (!this.data.data) {
			this.dataSource = new ExecutionQTest();
		} else {
			this.spinnerService.show();
			this.executionQTestService.getExecutionTestbyId(this.data.data.id).pipe(takeUntil(this.destroy$)).subscribe((data: ExecutionQTest) => {
				this.dataSource = data;
				this.spinnerService.hide();
				if (this.dataSource.executionQTestEssayGroup) {
					for (let index = 0; index < this.dataSource.executionQTestEssayGroup?.length; index++) {
						const element = this.dataSource.executionQTestEssayGroup[index];

						for (let indexEf = 0; indexEf < element.essayValues.length; indexEf++) {
							const elementEf = element.essayValues[indexEf];

							const fields = elementEf.fields?.map(i => FieldUtils.objectToField(i)).sort((v1, v2) => v1.id - v2.id);
							elementEf.fields = fields;

							if (elementEf.sensors) {
								const sensors = elementEf.sensors.map(i => {
									i.idVariable = elementEf.idVariable;

									return SensorUtils.objectToSensor(i);
								});
								elementEf.sensors = sensors;
							}

							this.dataSource.executionQTestEssayGroup[index].essayValues[indexEf] = elementEf;
						}
						this.dataSource.executionQTestEssayGroup.forEach(essay => essay.essayValues.sort((a, b) => a.idVariable - b.idVariable));

						this.equipmentAutoComplete = new Map<number, InternalEquipment[]>();

						this.reloadGraphMap();
					}
				}

				if (this.dataSource.executionQTestDataObservations) {
					this.dataSource.executionQTestDataObservations.sort((a, b) => a.position - b.position);
				}

				this.itemGroupReserve = _.cloneDeep(this.dataSource.executionQTestItemGroup);
				this.validateSaveMultiple();
				this.validateCriticalInstrumental();

				/*if (this.dataSource.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION) {
					if (this.dataSource.executionQTestOQVerification && this.dataSource.executionQTestOQVerification.some(oqv => !oqv.regUser)) {
						const uuidDevExists = [];
						this.dataSource.executionQTestOQVerification.forEach(eoq => {
							const test = this.data.tests.find(dtf => dtf.idTestType === eoq.idTestType);

							if (test) {
								eoq.selectedResult = test.according;
								eoq.regUser = 'qloud';
								if (test.deviations?.length > 0) {
									const deleteObs = _.cloneDeep(this.dataSource.executionQTestDataObservations?.filter(eob => eob.uuidDeviation));
									eoq.uuidDeviation = test.deviations.map(edt => edt.uuid);
									if (deleteObs && deleteObs.length > 0) {
										for (let indexItg = 0; indexItg < this.dataSource.executionQTestOQVerification?.length; indexItg++) {
											const elementItg = this.dataSource.executionQTestOQVerification[indexItg];
											
											elementItg.observations = elementItg.observations.filter(empo => !deleteObs.some(dob => dob.uuid === empo));
										}
									}
								}
							}
						});

						this.dataSource.executionQTestOQVerification?.forEach(eoq => {
							const test = this.data.tests.find(dtf => dtf.idTestType === eoq.idTestType);
							if (test) {
								let maxPosition = this.dataSource.executionQTestDataObservations != null ? this.dataSource.executionQTestDataObservations.map(item => item.position).filter(position => position !== null && position !== undefined).reduce((max, current) => (current > max ? current : max), 0) : 0;
								for (let index = 0; index < test.deviations.length; index++) {
									const element = test.deviations[index];
									if (!uuidDevExists.includes(element.uuid)) {
										const resUuid = uuid();
										const isClosed = element.executionQTestDeviationData?.some(eqdd => eqdd.idType === 5 && eqdd.closed);
										const dataValuation = element.executionQTestDeviationData.find(etd => etd.idType === 2);

										const valuation = dataValuation ? dataValuation.valuation === 1 ? this.translate.instant("valuation.critical") : dataValuation.valuation === 2 ?  this.translate.instant("valuation.mayor") : (dataValuation.valuation === 3 ?  this.translate.instant("valuation.minor") : "") : "";

										let obs = new ExecutionQTestDataObservations();
										obs.idExecutionTest = this.data.data.id;

										if (isClosed) {
											obs.description = this.translate.instant('executionEdit.test.deviation.obs.closed', {valuation: valuation, number: element.codeDeviation});
										} else {
											obs.description = this.translate.instant('executionEdit.test.deviation.obs.open', {valuation: valuation, number: element.codeDeviation});
										}

										obs.autogenerated = true;
										obs.position = maxPosition + 1;

										obs.uuid = resUuid;
										
										uuidDevExists.push(element.uuid);

										this.dataSource.executionQTestOQVerification.forEach((eqot => {
											if (eqot.uuidDeviation?.includes(element.uuid)) {
												if (!eqot.observations) {
													eqot.observations = [];
												}
												eqot.observations.push(resUuid);
											}
										}));

										if (!this.dataSource.executionQTestDataObservations) {
											this.dataSource.executionQTestDataObservations = [];
										}

										this.executionQTestDataObservationsService.save(obs).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDataObservations) => {
										this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
											this.dataSource.executionQTestDataObservations = item;
											if (this.dataSource.executionQTestDataObservations) {
												this.dataSource.executionQTestDataObservations.sort((a, b) => a.position - b.position);
											}
											this.obsTestTable.renderRows();
											this.spinnerService.hide();
										}, error => {
											console.log(error);
											this.spinnerService.show();
										});
									})
									}
								}
							}
						});
					}
				}

				if (this.dataSource.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING) {
					if (this.dataSource.executionQTestOQVerification && this.dataSource.executionQTestOQVerification.some(oqv => !oqv.regUser)) {
						const uuidDevExists = [];
						this.dataSource.executionQTestOQVerification.forEach(eoq => {
							const test = this.data.tests.find(dtf => dtf.idTestType === eoq.idTestType);

							if (test) {
								eoq.selectedResult = test.according;

								if (test.deviations?.length > 0) {
									const deleteObs = _.cloneDeep(this.dataSource.executionQTestDataObservations?.filter(eob => eob.uuidDeviation));
									eoq.uuidDeviation = test.deviations.map(edt => edt.uuid);
									if (deleteObs && deleteObs.length > 0) {
										for (let indexItg = 0; indexItg < this.dataSource.executionQTestOQVerification?.length; indexItg++) {
											const elementItg = this.dataSource.executionQTestOQVerification[indexItg];
											
											elementItg.observations = elementItg.observations.filter(empo => !deleteObs.some(dob => dob.uuid === empo));
										}
									}
								}
							}
						});

						this.dataSource.executionQTestOQVerification?.forEach(eoq => {
							const test = this.data.tests.find(dtf => dtf.idTestType === eoq.idTestType);
							if (test) {
								let maxPosition = this.dataSource.executionQTestDataObservations != null ? this.dataSource.executionQTestDataObservations.map(item => item.position).filter(position => position !== null && position !== undefined).reduce((max, current) => (current > max ? current : max), 0) : 0;
								for (let index = 0; index < test.deviations.length; index++) {
									const element = test.deviations[index];
									if (!uuidDevExists.includes(element.uuid)) {
										const resUuid = uuid();
										const isClosed = element.executionQTestDeviationData?.some(eqdd => eqdd.idType === 5 && eqdd.closed);
										const dataValuation = element.executionQTestDeviationData.find(etd => etd.idType === 2);

										const valuation = dataValuation ? dataValuation.valuation === 1 ? this.translate.instant("valuation.critical") : dataValuation.valuation === 2 ?  this.translate.instant("valuation.mayor") : (dataValuation.valuation === 3 ?  this.translate.instant("valuation.minor") : "") : "";

										let obs = new ExecutionQTestDataObservations();
										obs.idExecutionTest = this.data.data.id;

										if (isClosed) {
											obs.description = this.translate.instant('executionEdit.test.deviation.obs.closed', {valuation: valuation, number: element.codeDeviation});
										} else {
											obs.description = this.translate.instant('executionEdit.test.deviation.obs.open', {valuation: valuation, number: element.codeDeviation});
										}

										obs.autogenerated = true;
										obs.position = maxPosition + 1;

										obs.uuid = resUuid;
										
										uuidDevExists.push(element.uuid);

										this.dataSource.executionQTestOQVerification.forEach((eqot => {
											if (eqot.uuidDeviation?.includes(element.uuid)) {
												if (!eqot.observations) {
													eqot.observations = [];
												}
												eqot.observations.push(resUuid);
											}
										}));

										if (!this.dataSource.executionQTestDataObservations) {
											this.dataSource.executionQTestDataObservations = [];
										}

										this.executionQTestDataObservationsService.save(obs).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDataObservations) => {
										this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
											this.dataSource.executionQTestDataObservations = item;
											if (this.dataSource.executionQTestDataObservations) {
												this.dataSource.executionQTestDataObservations.sort((a, b) => a.position - b.position);
											}
											this.obsTestTable.renderRows();
											this.spinnerService.hide();
										}, error => {
											console.log(error);
											this.spinnerService.show();
										});
									})
									}
								}
							}
						});
					}
				}*/
			});

			if (this.attachmentsComponent instanceof QueryList) {
				this.attachmentsComponent = this.attachmentsComponent.first as ExecutionEditTestAttachmentsComponent;
			}

			if (this.attachmentsComponent) {
				this.attachmentsComponent.setIdExecution(this.data.data.idExecution);
				this.attachmentsComponent.setIdStatus(this.data.idStatus);
				this.attachmentsComponent.setIdTest(this.data.data.id);
			}

			if (this.data.notSelectedTest) {
				this.openCreateDialogTestObservations(true);
			}
		}
	}


	ngAfterViewInit(): void {
		if (this.attachmentsComponent instanceof QueryList) {
			this.attachmentsComponent = this.attachmentsComponent.first as ExecutionEditTestAttachmentsComponent;
		}

		if (this.attachmentsComponent) {
			this.attachmentsComponent.setIdExecution(this.data.data.idExecution);
			this.attachmentsComponent.setIdStatus(this.data.idStatus);
			this.attachmentsComponent.setIdTest(this.data.data.id);
		}
	}

	onChangeSelectionOption(): void {
		this.displayedColumns = [];
		this.displayedColumns.push('verificationTypeDesc');
		if (this.testConfig.expectedResult) {
			this.displayedColumns.push('expectedResult')
		}

		if (this.testConfig.obtainedResult) {
			this.displayedColumns.push('obtainedResult')
		}

		if (this.testConfig.testResult) {
			this.displayedColumns.push('testResult')
		}

		this.columnsToDisplay = this.displayedColumns.slice();
	}

	onOkClick(): void {
		this.spinnerService.show();
		const errs = [];

		if (this.testConfig.expectedResult) {
			if (this.dataSource.executionQTestItemGroup != null) {
				for (let index = 0; index < this.dataSource.executionQTestItemGroup.length; index++) {
					const element = this.dataSource.executionQTestItemGroup[index];

					if (!element.executionQTestItems) {
						errs.push(this.translate.instant('executionTest.probe.add.error'));
					} else {
						// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
						for (let index = 0; index < element.executionQTestItems.length; index++) {
							if (!element.executionQTestItems[index] && this.testConfig.item) {
								errs.push(this.translate.instant('executionTest.verificationType.item.description.error'));
							} else {
								if (!element.executionQTestItems[index].description) {
									errs.push(this.translate.instant('executionTest.verificationType.item.error'));
								}
								// eslint-disable-next-line @typescript-eslint/prefer-for-of, max-len
								for (let indexItemValue = 0; indexItemValue < element.executionQTestItems[index].executionQTestItemVerification.length; indexItemValue++) {
									if (!element.executionQTestItems[index].executionQTestItemVerification[indexItemValue]) {
										errs.push(this.translate.instant('executionTest.verificationType.add.error'));
									} else {
										if (!element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].verification) {
											errs.push(this.translate.instant('executionTest.verificationType.descripction.error'));
										}

										for (let indexData = 0; indexData < element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple.length; indexData++) {
											if (!element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple) {
												errs.push(this.translate.instant('executionTest.verificationType.add.error'));
											} else {

												if (!element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple[indexData].resultDesc || element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple[indexData].resultDesc?.length === 0) {
													errs.push(this.translate.instant('executionTest.verificationType.resultDesc.error'));
												} else {
													if (element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple[indexData].selectedResult === 'not_according') {
														if (!element.executionQTestItems[index].executionQTestItemVerification[indexItemValue].executionQTestDataMultiple[indexData].executionQTestDeviations) {
															errs.push(this.translate.instant('executionTest.deviation.resultDesc.empty'));
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}

		if (this.testConfig.probeTraceability) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (!this.dataSource.executionQTestProbeTraceability || this.dataSource.executionQTestProbeTraceability?.length === 0) {
				errs.push(this.translate.instant('executionTest.probe.add.error'));
			} else {
				// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
				for (let index = 0; index < this.dataSource.executionQTestProbeTraceability.length; index++) {
					if (!this.dataSource.executionQTestProbeTraceability[index].descriptionProbe) {
						errs.push(this.translate.instant('executionTest.probe.descripction.error'));
					}
				}
			}
		}

		if (this.testConfig.testResult) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (!this.dataSource.executionQTestResults || this.dataSource.executionQTestResults.length === 0) {
				errs.push(this.translate.instant('executionTest.probe.add.error'));
			} else {
				// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
				for (let index = 0; index < this.dataSource.executionQTestResults.length; index++) {
					if (!this.dataSource.executionQTestResults[index].resultExpected) {
						errs.push(this.translate.instant('executionTest.test.result.resultExpected.error'));
					} else {
						const valueTestData = this.dataSource.executionQTestResults[index].resultExpected?.filter(e => e === '');
						if (valueTestData != null && valueTestData?.length > 0) {
							errs.push(this.translate.instant('executionTest.verificationType.expectedResultDesc.error'));
						}
					}
					if (!this.dataSource.executionQTestResults[index].result || this.dataSource.executionQTestResults[index].result?.length === 0) {
						errs.push(this.translate.instant('executionTest.test.result.result.error'));
					}
					if (!this.dataSource.executionQTestResults[index].verification) {
						errs.push(this.translate.instant('executionTest.test.result.verification.error'));
					}
				}
			}
		}

		if (this.testConfig.bioTraceability) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (!this.dataSource.executionQTestBioindicadores || this.dataSource.executionQTestBioindicadores.length === 0) {
				errs.push(this.translate.instant('executionTest.bioindicador.add.error'));
			} else {
				// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
				for (let index = 0; index < this.dataSource.executionQTestBioindicadores.length; index++) {
					if (!this.dataSource.executionQTestBioindicadores[index].bioDescription) {
						errs.push(this.translate.instant('executionTest.bioindicador.description.error'));
					}
				}
			}
		}

		if (this.testConfig.testVerification) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if (!this.dataSource.executionQTestOQVerification || this.dataSource.executionQTestOQVerification.length === 0) {
				errs.push(this.translate.instant('executionTest.testVerification.add.error'));
			} else {
				// eslint-disable-next-line @typescript-eslint/prefer-for-of, @typescript-eslint/no-unsafe-member-access
				for (let index = 0; index < this.dataSource.executionQTestOQVerification.length; index++) {
					if (!this.dataSource.executionQTestOQVerification[index].test) {
						errs.push(this.translate.instant('executionTest.testVerification.test.error'));
					}
					if (!this.dataSource.executionQTestOQVerification[index].descriptionTest) {
						errs.push(this.translate.instant('executionTest.testVerification.description.test.error'));
					}
					if (!this.dataSource.executionQTestOQVerification[index].resultDesc || this.dataSource.executionQTestOQVerification[index].resultDesc?.length === 0) {
						errs.push(this.translate.instant('executionTest.testVerification.result.erro'));
					}
				}

			}
		}

		const valuationValid = this.dataSource.deviations?.some(dd => dd.executionQTestDeviationData?.some(ddd => ddd.idType === TestTypeDeviations.VALUATION && (!ddd.valuation || ddd.qualificationContinue === null || ddd.qualificationContinue === undefined)));

		if (valuationValid) {
			errs.push(this.translate.instant('execution.test.deviation.valuation.error'));
		}

		if (errs.length === 0) {
			const hasUnsignedData = this.dataSource.executionQTestItemGroup.some(ig =>
				ig.executionQTestItems.some(eqi =>
					eqi.executionQTestItemVerification.some(eqiv =>
						eqiv.executionQTestDataMultiple.some(eqdm =>
							(eqdm.obtainedResult || eqdm.selectedResult) && !eqdm.regUser
						)
					)
				)
			);

			if (hasUnsignedData) {
				this.spinnerService.hide();

				const msg = this.translate.instant('executionEdit.form.test.valid.save');
				const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message: msg } });

				dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
					if (result === true) {
						this.spinnerService.show();
						this.saveData();
					}
				});
			} else {
				this.saveData();
			}
		} else {
			this.spinnerService.hide();
			const error = errs.join('\n');
			this.snackBarService.sendError(error);
		}
	}

	saveData() {
		if (!this.dataSource.regUser) {
			this.dataSource.regUser = this.currentUser.username;
			this.dataSource.regDate = new Date();
		}

		this.dataSource.modUser = this.currentUser.username;
		this.dataSource.modDate = new Date();

		this.executionQTestService.updateTest(this.data.data.idExecution, this.dataSource).pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTest) => {
			this.spinnerService.hide();
			this.snackBarService.sendSuccess(this.translate.instant("executionEdit.test.save.ok"))
			result.deviations = this.data.deviations;
			this.dialogRef.close(result);
		}, error => {
			this.snackBarService.sendError(this.translate.instant("executionEdit.test.save.error"))
			console.log(error);
			this.spinnerService.hide();
		});
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	private requestReason(callback: (reason: string) => void) {
		const dialogRef = this.dialog.open(ReasonDialogComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
			if (result != null) {
				callback(result);
			} else {
				callback(null);
			}
		});
	}

	onImageSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (!input.files?.length) {
			return;
		}

		const file = input.files[0];
		this.fileName = file.name;

		const reader = new FileReader();

		reader.onload = () => {
			const base64String = reader.result as string;
			// Remover la parte "data:image/jpeg;base64,"
			const base64WithoutPrefix = base64String.split(',')[1];
			this.dataSource.imageTest = base64WithoutPrefix;
			console.log('Image in base64 without prefix:', this.dataSource.imageTest);
		};

		reader.readAsDataURL(file);
	}

	showLastTacometer(index: number) {
		return this.dataSource?.executionQTestProbeTraceability?.length === index + 1;
	}

	lookupEquipment(essayIndex: number, variableIndex: number, sensorIndex: number, idSensor: number, event): void {
		let results = this.getResultsLookup(idSensor);

		const filter = new EquipmentAutocompleteFilter();

		filter.query = event.target.value as string;
		filter.pageIndex = 0;
		filter.pageSize = 10;
		filter.sortBy = 'name';
		filter.sortDirection = 'asc';
		filter.forExecution = true;

		this.internalEquipmentService.findAutocomplete(filter).pipe(takeUntil(this.destroy$)).subscribe(item => {

			const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];

			const alreadySelected = variableSelected.sensors.filter((v, index) => index !== sensorIndex).map(v => v.serialNum);

			item.content = item.content.filter((c: InternalEquipment) => !alreadySelected.includes(c.serialNum));

			results = item.content;
			this.equipmentAutoComplete.set(idSensor, results);
		}, () => {
			results = [];

		});
	}

	onEquipmentSelected($event: any, trigger: MatAutocompleteTrigger, indexProbe: number): void {
		const equipmentSelected = $event.option.value as InternalEquipment;

		const eqCalibration = equipmentSelected.performances?.find(ep => ep.idActionType === EquipmentPerformances.CALIBRATION);
		
		if (eqCalibration.nearToExpire || eqCalibration.expired) {

			const expirationDate = DateTime.fromJSDate(eqCalibration.expirationDate).toFormat('dd/MMM/yyyy').toUpperCase().replace('./', '/');

			let message = this.translate.instant('executionEditQ.test.probe.form.error.nearToExpire', { expirationDate }) as string;

			if (eqCalibration.expired) {
				message = this.translate.instant('executionEditQ.test.probe.form.error.expired') as string;
			}

			const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
				if (result === true) {
					this.dataSource.executionQTestProbeTraceability[indexProbe].idEquipment = equipmentSelected.id;
					this.dataSource.executionQTestProbeTraceability[indexProbe].identifier = equipmentSelected.name;
					this.equipmentName = equipmentSelected.name;
				} else {
					this.dataSource.executionQTestProbeTraceability[indexProbe].idEquipment = null;
					this.dataSource.executionQTestProbeTraceability[indexProbe].identifier = null;
					this.equipmentName = null;
				}
			});
		} else {
			this.dataSource.executionQTestProbeTraceability[indexProbe].idEquipment = equipmentSelected.id;
			this.dataSource.executionQTestProbeTraceability[indexProbe].identifier = equipmentSelected.name;
			this.equipmentName = equipmentSelected.name;
		}
	}

	displayFn(eq?: InternalEquipment | string | { name: string }): string {
		if (!eq) {
			return null;
		}

		let res: string = null;

		if (typeof eq === 'string') {
			res = eq;
		} else if (eq instanceof InternalEquipment || eq.name != null) {
			res = eq.name;
		}

		return res;
	}

	onSelectedVerificationResult(event: MatSelectChange, indexGroup: number, indexItem: number, idxVerification: number, idxMultuple: number) {
		const resSelected = this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple];
		if (event?.value === 'not_according') {
			const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					protocolNumber: this.data.protocolNumber,
					deviation: new ExecutionQTestDeviations(),
					idStatus: this.data.idStatus,
					idExecution: this.data.data.idExecution,
					idExecutionTest: this.data.data.id,
					isEditList: false,
					executionNumber: this.data.ex.documentCode,
					deviationsComplete: this.data.deviations
				}
			});

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
				if (result) {
					if (this.data.deviations) {
						this.data.deviations.push(result);
					}
					if (result.observation) {
						if (!this.dataSource.executionQTestDataObservations) {
							this.dataSource.executionQTestDataObservations = [];
						}
						this.dataSource.executionQTestDataObservations.push(result.observation);
						if (!this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].observations) {
							this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].observations = [];
						}

						this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].observations.push(result.uuidObs);
						this.obsTestTable.renderRows();
					}
					if (!this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation) {
						this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation = [];
					}
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation.push(result.uuid);

					this.devTable.renderRows();
				}
			});
		} else if (event?.value === 'not_applicable') {
			if (this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation) {
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation = null;
			}
			this.requestReason((reason) => {
				if (reason) {
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].reasonChangeNoApplicable = reason;
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
				} else {
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
				}
			});
		} else {
			const dataDev = this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation;
			if (dataDev) {
				const dataDevResolution = this.data.deviations?.filter(ddt => dataDev.includes(ddt.uuid));
				if (dataDevResolution) {
					const devResolved = dataDevResolution.some(dvr => dvr.executionQTestDeviationData.some(e => e.idType === TestTypeDeviations.DEVIATION_RESOLUTION && e.resolved));

					if (devResolved) {
						const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
							data: {
								message: this.translate.instant('executionEdit.deviation.change.result') as string
							}
						});
						dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
							if (result === true) {
								this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation = null;
								this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
							}
						});
					} else {
						this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation = null;
						this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
					}
				} else {
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].uuidDeviation = null;
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
				}
			}
		}
	}

	showDeviationSelected(indexGroup: number, indexItem: number, idxVerification: number, idxMultuple: number) {
		/*const data =  this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple];
		if (data?.uuidDeviation) {
			const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					protocolNumber: this.data.protocolNumber,
					deviation: _.cloneDeep(this.data.deviations?.filter(df => data?.uuidDeviation?.includes(df.uuid))),
					idStatus: this.data.idStatus,
					idExecution: this.data.data.idExecution,
					idExecutionTest: this.data.data.id,
					isEditList: false,
				}
			});

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
				if (result) {
					this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].executionQTestDeviations = result;
				} else {
					if (!this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].executionQTestDeviations) {
						this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].selectedResult = null;
					}
				}
			});
		}*/
		const data = this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple];

		const dialogRef = this.dialog.open(ExecutionEditQDeviationListComponent, {
			minWidth: '70%',
			maxHeight: '95vh',
			data: {
				deviations: _.cloneDeep(this.data.deviations?.filter(df => data?.uuidDeviation?.includes(df.uuid))),
				protocolNumber: this.data.protocolNumber,
				idStatus: this.data.idStatus,
				idExecution: this.data.data.idExecution,
				idExecutionTest: this.data.data.id,
				create: true,
				deviationSelected: _.cloneDeep(this.data.deviations?.filter(df => !data?.uuidDeviation?.includes(df.uuid))),
				deviationsComplete: _.cloneDeep(this.data.deviations),
				executionNumber: this.data.ex.documentCode
			}
		});
		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDeviations[]) => {
			if (Array.isArray(res) && res.length > 0) {
				if (!Array.isArray(this.data.deviations)) {
					this.data.deviations = [];
				}

				const deviationMap = new Map(this.data.deviations.map(d => [d.uuid, d]));

				res.forEach(element => {
					deviationMap.set(element.uuid, element);
					if (!data.uuidDeviation) {
						data.uuidDeviation = [];
					}
					data.uuidDeviation.push(element.uuid);
				});

				this.data.deviations = Array.from(deviationMap.values());
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].executionQTestDeviations = res;
			}
		});
	}

	showDeviationCriticalSelected(criticalInst: ExecutionQTestCriticalInstrumentation) {
		const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
			minWidth: '70%',
			maxHeight: '95vh',
			data: {
				protocolNumber: this.data.protocolNumber,
				deviation: _.cloneDeep(this.data.deviations?.filter(df => criticalInst?.uuidDeviation?.includes(df.uuid))),
				idStatus: this.data.idStatus,
				idExecution: this.data.data.idExecution,
				idExecutionTest: this.data.data.id,
				isEditList: false,
				uuid: criticalInst.uuid
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDeviations) => {
			if (Array.isArray(res) && res.length > 0) {
				if (!Array.isArray(this.data.deviations)) {
					this.data.deviations = [];
				}

				const deviationMap = new Map(this.data.deviations.map(d => [d.uuid, d]));

				res.forEach(element => {
					deviationMap.set(element.uuid, element);
					if (!criticalInst.uuidDeviation) {
						criticalInst.uuidDeviation = [];
					}
					criticalInst.uuidDeviation.push(element.uuid);
				});

				this.data.deviations = Array.from(deviationMap.values());
			}
		});

	}

	devCriticalIsClose(criticalInst: ExecutionQTestCriticalInstrumentation): boolean {
		/*if (criticalInst.uuidDeviation && criticalInst.uuidDeviation?.length > 0) {
			this.data.deviations?.find(fd => fd.uuid === cr)
			const continueQ = criticalInst.executionQTestDeviations?.executionQTestDeviationData?.find(e => e.idType === TestTypeDeviations.VALUATION && (e.qualificationContinue === null || !e.qualificationContinue));

			const closeData = criticalInst.executionQTestDeviations?.executionQTestDeviationData?.find(e => e.idType === TestTypeDeviations.DEVIATION_RESOLUTION);
			if (closeData) {
				return closeData.resolved && !continueQ;
			} else {
				return false;
			}
		} else {
			
		}*/
		return false;
	}

	onEssayTabChange(event: MatTabChangeEvent | number): void {
		let groupIndex: number;

		if (event instanceof MatTabChangeEvent) {
			groupIndex = event.index;
		} else {
			groupIndex = event;
		}

		this._groupItem = groupIndex;
	}

	displayCycle(group: ExecutionQTestItemGroup): boolean {
		return group.numCycle != null && group.numCycle != 1;
	}

	reloadPageEmit(event: { idExecution: number }): void {
		//this.reloadPage(event.idExecution);
	}

	essayActiveEmit(event): void {
		this.dataSource.executionQTestEssayGroup.find(e => e.id === event.essayId).active = event.active;
	}

	private setSensor(essayIndex: number, variableIndex: number, sensorIndex: number, sensor: Sensor): void {
		this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].sensors[sensorIndex] = sensor;
	}

	essayActiveReasonEmit(event): void {
		this.dataSource.executionQTestEssayGroup.find(e => e.id === event.essayId).reasonActive = event.reason;
	}

	updateAttachmentList(): void {
		if (this.attachmentsComponent instanceof QueryList) {
			this.attachmentsComponent = this.attachmentsComponent.first as ExecutionEditTestAttachmentsComponent;
		}

		this.attachmentsComponent.setIdExecution(this.dataSource.id);
	}

	onEssayTestTabChange(event: MatTabChangeEvent | number, changeVariableIndex = true): void {
		let essayIndex: number;

		if (event instanceof MatTabChangeEvent) {
			essayIndex = event.index;
		} else {
			essayIndex = event;
		}

		this._essayIndex = essayIndex;

		if (changeVariableIndex) {
			this._variableIndex = 0;
		}

		if (this.data.data.idTestType != TestTypeEnum.TEST_BOWIE_DICK) {
			this.updateGraphByIndex(this._essayIndex, this._variableIndex, false);
		}

		window.setTimeout(() => {
			if (changeVariableIndex) {
				this._variableIndex = 0;
			}

			this.cd.markForCheck();
		});

		const tab = this.dataSource.executionQTestEssayGroup[this._essayIndex].essayValues[this._variableIndex];

		this.variableUnits = [];

		if (tab != null && tab.idVariable != null) {
			this.variableTypeService.findUnits(tab.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
				this.variableUnits = res;

				if (tab.idUnit == null || !this.variableUnits.map(v => v.id).includes(tab.idUnit)) {
					this.onUnitChange(this._variableIndex, res[0]);
				}
			});
		}
	}

	onEssayActiveChange(essay: ExecutionQTestEssayGroup, event: MatCheckboxChange): void {
		const value = event.checked;
		essay.active = value;
		this.dataSource.executionQTestEssayGroup.find(e => e.id === essay.id).active = value;
	}

	onEssayActiveReasonChange(essay: ExecutionQTestEssayGroup, event): void {
		this.dataSource.executionQTestEssayGroup.find(e => e.id === essay.id).reasonActive = essay.reasonActive;
	}

	onVariableTabChange(event: MatTabChangeEvent | number): void {
		let essayIndex: number;

		if (event instanceof MatTabChangeEvent) {
			essayIndex = event.index;
		} else {
			essayIndex = event;
		}

		this._variableIndex = essayIndex;

		const group = this.dataSource.executionQTestEssayGroup[this._essayIndex];
		const tab = this.dataSource.executionQTestEssayGroup[this._essayIndex].essayValues[this._variableIndex];

		this.variableUnits = [];
		if (tab != null && tab.idVariable != null) {
			this.variableTypeService.findUnits(tab.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
				this.variableUnits = res;

				let unitRest;
				if (tab.idUnit == null || !this.variableUnits.map(v => v.id).includes(tab.idUnit)) {
					const isWarehouse = this.data.ex.equipments.some(element => element.idType === EquipmentTypeQualificationEnum.WAREHOUSE);
					if (tab.idVariable === VariableTypeEnum.LETHALITY && group.idEssayType === EssayTypeEnum.PENETRACION_CON_CARGA && isWarehouse) {
						unitRest = res.find(eur => eur.id === VariableUnitEnum.SECOND_LETHALITY);
					} else {
						unitRest = res.find(eur => eur.id === VariableUnitEnum.MINUTES_LETHALITY);
					}

					if (!unitRest) {
						unitRest = res[0];
					}

					this.onUnitChange(this._variableIndex, unitRest);
				}
			});
		}
		this.updateGraphByIndex(this._essayIndex, this._variableIndex, false);
	}

	onUnitChange(indexVariable: number, event: MatSelectChange | VariableUnit): void {

		const essay = this.dataSource.executionQTestEssayGroup[this._essayIndex].essayValues[indexVariable];

		let unit: VariableUnit;

		if (event instanceof MatSelectChange) {
			unit = this.variableUnits.find(v => v.id === event.value);
		} else {
			unit = event;
		}

		if (essay != null && unit != null) {
			essay.idUnit = unit.id;
			essay.unitName = unit.unit;

			this.dataSource.executionQTestEssayGroup[this._essayIndex].essayValues[indexVariable] = essay;
		}
	}

	enableEditCriteria(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus);
	}

	openEditField(essayIndex: number, variableIndex: number, fieldIndex: number): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essay.essayValues[variableIndex];

		const field = variableSelected.fields[fieldIndex];

		const dialogRef = this.dialog.open(ExecutionQEditEssayFieldComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				field: _.cloneDeep(field)
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Field) => {

			if (result != null) {
				variableSelected.fields[fieldIndex] = result;

				if (result.idField === FieldEnum.REHEARSAL_TIME) {
					this.reloadGraphMap();
				}
			}
		});
	}

	isSelectedMulti(valuesStr: string | string[], valueCheck: string): boolean {
		if (valuesStr == null || valueCheck == null) {
			return false;
		}

		let values = [];
		if (typeof valuesStr === 'string') {
			values = valuesStr.split(';');
		} else {
			values = valuesStr;
		}

		return values.includes(valueCheck);
	}

	showCriteria(crit: Criteria): string {
		return EssayUtils.getCriteriaToShowThermal(crit, this.translate);
	}

	enableEditSensor(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus);
	}

	openDialogCorrectSensors(essayIndex: number, indexVariable: number): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essay.essayValues[indexVariable];

		const dialogRef = this.dialog.open(ExecutionQEditDialogCorrectSensorComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idExecutionTest: this.data.data.id,
				idEssay: essay.id,
				idEssayVariable: variableSelected.id,
				sensors: variableSelected.sensors
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: boolean) => {
			if (res) {
				//this.reloadPage();
			}
		});
	}

	disableSerialNumLabel(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		if (this.data.data.idTestType !== TestTypeEnum.TEST_BOWIE_DICK) {
			return !allowedStatuses.includes(this.data.idStatus)
		} else {
			return true;
		}
	}

	onSensorChange(
		essayIndex: number, variableIndex: number, sensorIndex: number, event: any, trigger: MatAutocompleteTrigger, confirmEq = false): void {
		const equipmentSelected = event.option.value as InternalEquipment;

		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		if (!confirmEq) {
			const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];

			variableSelected.sensors.forEach((s: Sensor, index: number) => {
				if (index === sensorIndex) {
					return;
				}

				if (s.serialNum === equipmentSelected.serialNum) {

					const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
						data: {
							message: this.translate.instant('executionEdit.essays.sensor.form.error.alreadyInUse') as string
						}
					});

					dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
						if (result === true) {
							this.onSensorChange(essayIndex, variableIndex, sensorIndex, event, trigger, true);
						} else {
							sensor.equipmentName = null;
							sensor.serialNum = null;

							this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);
							this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'serialNum');
						}

						event.stopPropagation();
						trigger.closePanel();
					});

					return;
				}
			});
		}

		sensor.equipmentName = null;
		sensor.serialNum = null;

		const eqCalibration = equipmentSelected.performances?.find(ep => ep.idActionType === EquipmentPerformances.CALIBRATION);

		if (eqCalibration.nearToExpire || eqCalibration.expired) {

			sensor.equipmentName = null;
			sensor.serialNum = null;
			sensor.idEquipment = null;

			this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);
			this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'serialNum');

			const expirationDate = DateTime.fromJSDate(eqCalibration.expirationDate).toFormat('dd/MMM/yyyy').replace('./', '/').toUpperCase();

			let message = this.translate.instant('executionEdit.essays.sensor.form.error.nearToExpire', { expirationDate }) as string;

			if (eqCalibration.expired) {
				message = this.translate.instant('executionEdit.essays.sensor.form.error.expired') as string;
			}

			const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
				const sen = this.getSensor(essayIndex, variableIndex, sensorIndex);

				if (result === true) {
					sen.equipmentName = equipmentSelected.name;
					sen.serialNum = equipmentSelected.serialNum;
					sen.idEquipment = equipmentSelected.id;

					this.setSensor(essayIndex, variableIndex, sensorIndex, sen);
					this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'serialNum');
				} else {
					sen.equipmentName = null;
					sen.serialNum = null;
					sen.idEquipment = null;
					this.setSensor(essayIndex, variableIndex, sensorIndex, sen);
					this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'serialNum');
				}
				trigger.closePanel();
			});
		} else {
			sensor.equipmentName = equipmentSelected.name;
			sensor.serialNum = equipmentSelected.serialNum;
			sensor.idEquipment = equipmentSelected.id;

			this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);
			this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'serialNum');
		}
	}

	updateSensorDependency(essayIndex: number, variableIndex: number, sensorIndex: number, field: string): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];
		const currentVariable = essay.essayValues[variableIndex];

		essay.essayValues.forEach((essayVal, essayValIndex) => {
			if (essayVal === currentVariable || essayVal.idConfigDependsOn == null || essayVal.idConfigDependsOn !== currentVariable.idConfig) {
				return;
			}

			const sensor = currentVariable.sensors[sensorIndex];
			const sensorDepends = essayVal.sensors[sensorIndex];

			if (sensor == null || sensorDepends == null) {
				return;
			}

			if (field === 'serialNum') {
				sensorDepends.equipmentName = sensor.equipmentName;
				sensorDepends.serialNum = sensor.serialNum;
			} else if (field === 'photo') {
				sensorDepends.idPhoto = sensor.idPhoto;
			} else if (field === 'primary') {
				sensorDepends.idPrimaryDataFile = sensor.idPrimaryDataFile;
			} else if (field === 'config') {
				sensorDepends.evaluate = sensor.evaluate;
				sensorDepends.outer = sensor.outer;
				sensorDepends.evaluateReason = sensor.evaluateReason;
				sensorDepends.location = sensor.location;
				sensorDepends.locationChangeReason = sensor.locationChangeReason;
			}

			this.setSensor(essayIndex, essayValIndex, sensorIndex, sensorDepends);

		});
	}

	private getSensor(essayIndex: number, variableIndex: number, sensorIndex: number): Sensor {
		return this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].sensors[sensorIndex];
	}

	getResultsLookup(idSensor: number): InternalEquipment[] {
		return this.equipmentAutoComplete.get(idSensor);
	}


	disableUploadPhotoButton(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];
		return !allowedStatuses.includes(this.data.idStatus);
	}

	disableUploadExcelButton(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return !allowedStatuses.includes(this.data.idStatus);
	}

	disableUploadOriginalButton(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return !allowedStatuses.includes(this.data.idStatus);
	}

	showPhotoButton(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		return ExecutionUtils.showPhotoButtonEssayGroup(this.dataSource.executionQTestEssayGroup, essayIndex, variableIndex, sensorIndex);
	}

	showExcelButton(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		return true;
	}

	showPrimaryButton(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		return true;
	}

	photoAlreadyUploaded(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return sensor.idPhoto != null;
	}

	excelAlreadyUploaded(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return sensor.idExcel != null;
	}

	styleUploadPhotoButton(essayIndex: number, variableIndex: number, sensorIndex: number): string {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return (!this.disableUploadPhotoButton() && sensor.idPhoto != null) ? '' : 'opacity50';
	}

	styleUploadExcelButton(essayIndex: number, variableIndex: number, sensorIndex: number): string {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return (!this.disableUploadExcelButton() && sensor.idExcel != null) ? '' : 'opacity50';
	}

	styleUploadOriginalButton(essayIndex: number, variableIndex: number, sensorIndex: number): string {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return (!this.disableUploadOriginalButton() && sensor.idPrimaryDataFile != null) ? '' : 'opacity50';
	}

	openDialogSensorPhoto(essayIndex: number, variableIndex: number, sensorIndex: number): void {
		const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		const dialogRef = this.dialog.open(ExecutionQEditAttachmentDetailsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idSensor,
				idAttachment: sensor.idPhoto,
				accept: 'image/*',
				isPhoto: true,
				disableUpload: this.disableUploadPhotoButton(),
				sensor,
				idVariable: variableSelected.idVariable,
				type: 'photo'
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Sensor) => {
			if (result != null) {
				this.setSensor(essayIndex, variableIndex, sensorIndex, result);
			}
		});
	}

	openDialogSensorExcel(essayIndex: number, variableIndex: number, sensorIndex: number): void {
		const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		const dialogRef = this.dialog.open(ExecutionQEditAttachmentDetailsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idSensor,
				idAttachment: sensor.idExcel,
				accept: '.xlsx, .xls, .csv, .pdf',
				isPhoto: false,
				disableUpload: this.disableUploadExcelButton(),
				sensor,
				idVariable: variableSelected.idVariable,
				type: 'excel'
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Sensor) => {
			if (result != null) {
				this.setSensor(essayIndex, variableIndex, sensorIndex, result);

				this.checkFrequency(essayIndex, variableIndex);
			}
		});
	}

	openDialogSensorPrimary(essayIndex: number, variableIndex: number, sensorIndex: number): void {
		const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		const dialogRef = this.dialog.open(ExecutionQEditAttachmentDetailsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idSensor,
				idAttachment: sensor.idPrimaryDataFile,
				accept: '*',
				isPhoto: false,
				disableUpload: this.disableUploadOriginalButton(),
				sensor,
				idVariable: variableSelected.idVariable,
				type: 'primary'
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Sensor) => {
			if (result != null) {
				this.setSensor(essayIndex, variableIndex, sensorIndex, result);
			}
		});
	}

	private checkFrequency(essayIndex: number, variableIndex: number): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];
		const currentVariable = essay.essayValues[variableIndex];

		const fieldFreq = currentVariable.fields?.find(f => f.idField === FieldEnum.FREQUENCY);

		const dates = currentVariable.sensors.find(s => !ArrayUtils.isEmpty(s.data)).data.map(d => d.date)
			.sort((d1, d2) => d1.getTime() - d2.getTime());

		const lastDate = dates[dates.length - 1];
		const lastDate2 = dates[dates.length - 2];

		const diff = DateUtils.getMinutesBetween(lastDate, lastDate2);

		const value: number = +fieldFreq?.value;

		if (value !== diff) {

			const diffStr = diff > 0 ? FieldUtils.minutesToHHMMSS(diff, this.translate) : null;
			const valueStr = value > 0 ? FieldUtils.minutesToHHMMSS(value, this.translate) : null;

			if (diffStr == null || valueStr == null) {
				return;
			}

			const message = this.translate.instant('executionEdit.essays.form.sensor.diffFrequency',
				{ diff: diffStr, value: valueStr }) as string;

			const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
				data: { message }
			});

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
				if (result === true) {
					this.requestReason((reason) => {
						fieldFreq.value = diff;
						fieldFreq.valueChangeReason = reason;
					});
				}
			});

		}
	}

	primaryAlreadyUploaded(essayIndex: number, variableIndex: number, sensorIndex: number): boolean {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		return sensor.idPrimaryDataFile != null;
	}

	onPhotoUploadSensor(essayIndex: number, variableIndex: number, sensorIndex: number, event): void {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		const file = event.target.files[0] as File;

		this.spinnerService.show();

		PhotoUtils.fixImage(file, this.imageCompress, (res) => {
			this.attachmentService.uploadPhotoToSensor(sensor.id, res).pipe(takeUntil(this.destroy$)).subscribe((item: number) => {
				sensor.idPhoto = item;

				this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);
				this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'photo');

				this.spinnerService.hide();

				this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.uploadImage.ok') as string);
			}, () => {
				this.spinnerService.hide();

				this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadImage.error.generic') as string);
			});
		});
	}

	onExcelUploadSensor(essayIndex: number, variableIndex: number, sensorIndex: number, event): void {
		const essaySelected = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essaySelected.essayValues[variableIndex];
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		const cond = sensor.idEquipment != null;

		if (cond === false) {
			this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadExcel.error.idEquipmentMissing') as string);

			return;
		}

		const file: File = event.target.files[0] as File;

		if (file.name.endsWith('.pdf')) {
			this.spinnerService.show();

			this.attachmentService.convertPdfToCsv(file, variableSelected.idVariable).pipe(takeUntil(this.destroy$)).subscribe(csv => {
				csv.name = file.name;
				this.uploadDataExcel(essayIndex, variableIndex, sensorIndex, csv as File);
			});
		} else {
			this.uploadDataExcel(essayIndex, variableIndex, sensorIndex, file);
		}

	}

	onPrimaryDataUploadSensor(essayIndex: number, variableIndex: number, sensorIndex: number, event): void {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const res = sensor.idEquipment != null;

		if (res === false) {
			this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadExcel.error.idEquipmentMissing') as string);

			return;
		}

		const file = event.target.files[0] as File;

		this.spinnerService.show();
		this.attachmentService.uploadPrimaryFileToSensor(sensor.id, file).pipe(takeUntil(this.destroy$)).subscribe((item: number) => {
			sensor.idPrimaryDataFile = item;

			this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);
			this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'primary');

			this.spinnerService.hide();

			this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.uploadPrimaryData.ok') as string);
		}, () => {
			this.spinnerService.hide();

			this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadPrimaryData.error.generic') as string);
		});
	}

	setForceAccording(event: MatCheckboxChange): void {
		if (event.checked) {
			this.requestReason((reason) => {
				if (reason) {
					this.dataSource.forceAccording = true;
					this.dataSource.accordingReason = reason;

					this.cd.detectChanges();
				} else {
					this.dataSource.forceAccording = true;
					this.cd.detectChanges();

					setTimeout(() => {
						this.dataSource.forceAccording = false;
						this.dataSource.accordingReason = null;
						this.cd.detectChanges();
					}, 0);
				}

			});
		} else {
			this.dataSource.forceAccording = false;
			this.dataSource.accordingReason = null;
			this.cd.detectChanges();
		}
	}

	enableEditEssay(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus)
	}

	private uploadDataExcel(essayIndex: number, variableIndex: number, sensorIndex: number, file: File): void {
		const essaySelected = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essaySelected.essayValues[variableIndex];

		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const idSensor = sensor.id;

		if (idSensor == null) {
			this.snackBarService.sendWarn(this.translate.instant('executionEdit.essays.form.sensor.notUpdated') as string);

			return;
		}

		this.spinnerService.show();

		ExcelUtils.excelToSensorDataQualificates(file, this.attachmentService, variableSelected.idVariable, false, 1).then((data: SensorData[]) => {

			data.forEach(item => {
				item.serialNum = sensor.serialNum;
				item.equipmentName = sensor.equipmentName;
				item.idEquipment = sensor.idEquipment;
			});

			const map = ArrayUtils.groupBy(data, (item: SensorData) => item.idVariable) as Map<number, SensorData[]>;

			if (map.size > 1) {
				data = map.get(variableSelected.idVariable);
			}

			data.forEach(item => delete item.posEquipment);

			sensor.data = data;
			this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);

			data = data.filter(item => item.date != null && !isNaN(item.date.getTime()));

			this.attachmentService.uploadExcelToSensor(idSensor, file, data).pipe(takeUntil(this.destroy$)).subscribe((item: number) => {
				sensor.idExcel = item;

				sensor.data = data;

				this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);

				let mapValue: SensorData[] = [];
				variableSelected.sensors.filter(sen => sen.data != null && sen.data.length !== 0)
					.forEach(sen => mapValue = [...mapValue, ...sen.data]);

				const key = new EventEssayVariableKeys();
				key.essayIndex = essaySelected.id;
				key.variableIndex = variableSelected.idVariable;

				this.graphMap.set(key.toString(), mapValue);

				this.updateGraphByIndex(essayIndex, variableIndex, true);

				this.spinnerService.hide();

				this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.uploadExcel.ok') as string);

				this.checkFrequency(essayIndex, variableIndex);
			}, () => {
				this.spinnerService.hide();

				this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadExcel.error.generic') as string);
			});

		}).catch(err => {
			console.error(err);
			this.snackBarService.sendError(err as string);
			this.spinnerService.hide();
		});
	}

	showDialogConfigBioindicator(essayIndex: number, variableIndex: number): void {
		const bio = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].bioindicatorsConfig;

		const dialogRef = this.dialog.open(ExecutionQEditBioindicatorsDetailsComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				bioindicator: _.cloneDeep(bio),
				idExecutionTest: this.data.data.id,
				type: 'bioindicator'
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: BioindicatorConfig) => {
			if (result != null) {
				this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].bioindicatorsConfig = result;
			}
		});

	}

	showDialogConfigEndotoxin(essayIndex: number, variableIndex: number): void {
		const bio = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].endotoxinsConfig;

		const dialogRef = this.dialog.open(ExecutionQEditBioindicatorsDetailsComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				bioindicator: _.cloneDeep(bio),
				idExecutionTest: this.data.data.id,
				type: 'endotoxin'
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: BioindicatorConfig) => {
			if (result != null) {
				this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].endotoxinsConfig = result;
			}
		});

	}

	onPhotoUploadBowieDick(event): void {
		const file = event.target.files[0] as File;

		PhotoUtils.fixImage(file, this.imageCompress, (res: File) => {
			this.spinnerService.show();

			this.attachmentService.uploadAttachmentToTestAndType(this.data.data.idExecution, this.data.data.id, res, AttachmentType.RESULTADO_BOWIE_DICK)
				.pipe(takeUntil(this.destroy$)).subscribe(() => {

					if (this.attachmentsComponent) {
						this.attachmentsComponent.setIdExecution(this.data.data.idExecution);
						this.attachmentsComponent.setIdStatus(this.data.idStatus);
						this.attachmentsComponent.setIdTest(this.data.data.id);
					}

					this.spinnerService.hide();

					this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.uploadImageBowieDick.ok') as string);
				}, () => {
					this.spinnerService.hide();

					this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadImageBowieDick.error.generic') as string);
				});
		});

	}

	showSetpoint(essayIndex: number, essayValueIndex: number): boolean {
		const totalSensors = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[essayValueIndex].sensors?.length;

		return essayValueIndex === 0 && totalSensors !== 0;
	}

	showRealLoad(essayIndex: number, essayValueIndex: number): boolean {
		const withoutLoadEssays = [EssayTypeEnum.DISTRIBUCION_EN_VACIO, EssayTypeEnum.TEST_VACIO];
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];
		const totalSensors = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[essayValueIndex].sensors?.length;

		return (essayValueIndex === 0 && totalSensors !== 0) && !withoutLoadEssays.includes(essay.idEssayType);
	}

	enableReasonModifyExpositionTime(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus);
	}

	openReasonModifyExpositionTime(event: MatCheckboxChange): void {

		if (event.checked === false) {
			this.reasonModifyExpositionTime = null;
			this.graph.reasonModifyExpositionTime = null;
			return;
		}

		const dialogRef = this.dialog.open(ExecutionQEditReasonExpositionTimeComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				reason: _.cloneDeep(this.reasonModifyExpositionTime)
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((reason: string) => {

			if (reason != null) {
				this.reasonModifyExpositionTime = reason;
				this.graph.reasonModifyExpositionTime = reason;
			}
		});
	}

	set reasonModifyExpositionTime(reason: string) {
		const variableSelected = this.dataSource.executionQTestEssayGroup[this._essayIndex].essayValues[this._variableIndex];

		if (variableSelected != null) {
			variableSelected.reasonModifyExpositionTime = reason;
		}
	}

	openUploadGeneric(essayIndex: number, variableIndex: number): void {
		const essaySelected = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essaySelected.essayValues[variableIndex];

		const bottomRef = this.bottomSheet.open(ExecutionQEditEssayBottomSheetUploadComponent, {
			data: {
				idStatusExecution: this.data.idStatus,
				essay: variableSelected
			}
		});

		bottomRef.afterDismissed().pipe(takeUntil(this.destroy$)).subscribe((res: { action: string, data: any }) => {
			if (res != null) {
				if (res.action === 'updateGraphByIndex') {
					this.updateGraphByIndex(essayIndex, variableIndex, true);
				} else if (res.action === 'updateSensor') {
					const sensorIndex = res.data.sensorIndex as number;
					const sensor = res.data.sensor as Sensor;
					const itsFirtsCall = res.data.itsFirtsCall as boolean;

					this.setSensor(essayIndex, variableIndex, sensorIndex, sensor);

					let mapValue: SensorData[] = [];
					variableSelected.sensors.filter(sen => sen.data != null && sen.data.length !== 0).forEach(sen => {
						mapValue = [...mapValue, ...sen.data];
					});

					const key = new EventEssayVariableKeys();
					key.essayIndex = essaySelected.id;
					key.variableIndex = variableSelected.idVariable;

					this.graphMap.set(key.toString(), mapValue);

					if (itsFirtsCall) {
						this.checkFrequency(essayIndex, variableIndex);
					}
					this.updateGraphByIndex(essayIndex, variableIndex, true);
				} else if (res.action === 'updateSensorPhoto' || res.action === 'updateSensorPrimary') {
					const sensor = res.data.sensor as Sensor;

					const indexSensor = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].sensors.findIndex(s => s.id === sensor.id
						&& s.location === sensor.location);

					const copyType = (res.action === 'updateSensorPhoto') ? 'photo' : ' primary';

					if (indexSensor > -1) {
						this.setSensor(essayIndex, variableIndex, indexSensor, sensor);
						this.updateSensorDependency(essayIndex, variableIndex, indexSensor, copyType);
					}
				} else if (res.action === 'reloadPage') {
					//this.reloadPage();
				}
			}
		});
	}

	copyToEssay(): void {
		const essaySelected = this.dataSource.executionQTestEssayGroup[this._essayIndex];
		let essaysToShow = this.dataSource.executionQTestEssayGroup.filter(e => e.id !== essaySelected.id);

		essaysToShow = essaysToShow.filter(essay => {
			const emptyList: SensorData[] = [];
			let data: SensorData[] = [];
			if (essay.essayValues[0].sensors) {
				data = emptyList.concat(...essay.essayValues[0].sensors?.map(s => s.data));

			}
			return !ArrayUtils.isEmpty(data);
		});

		if (ArrayUtils.isEmpty(essaysToShow)) {
			this.snackBarService.sendError('No hay ensayos desde el que copiar');
			return;
		}

		const dialogRef = this.dialog.open(ExecutionQEditCopyEssayComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				essays: essaysToShow
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: DialogDataCopyEssayResult) => {
			if (result != null) {
				this.spinnerService.show();

				this.executionQTestService.copyToEssay(this.data.data.id, result.idEssay, essaySelected.id, result.dateFrom, result.dateTo)
					.pipe(takeUntil(this.destroy$)).subscribe(() => {
						this.spinnerService.hide();

						this.snackBarService.sendSuccess(this.translate.instant('executionEdit.events.form.copyEssay.ok') as string);

						// this.reloadPage();
						this.onEssayTabChange(this._essayIndex);
					}, () => {
						this.spinnerService.hide();

						this.snackBarService.sendSuccess(this.translate.instant('executionEdit.events.form.copyEssay.error.generic') as string);
					});
			}
		});
	}

	showCopyToOtherEssay(): boolean {
		return this.dataSource.executionQTestEssayGroup.length > 1;
	}

	copySensorToAll(): void {
		if (this.dataSource.executionQTestEssayGroup[0].essayValues[0].sensors) {
			const sensors = this.dataSource.executionQTestEssayGroup[0].essayValues[0].sensors;

			this.dataSource.executionQTestEssayGroup.forEach((essay, essayIndex) => {
				essay.essayValues.forEach((variables, variableIndex) => {
					if (essayIndex === 0 && variableIndex === 0) {
						return;
					}

					variables.sensors.forEach((sensorToCopy, sensorToCopyIndex) => {
						let sensorFromCopy: Sensor = null;

						if (sensorToCopy.location === this.translate.instant('protocolEdit.dialog.essay.sensors.defaultLocation')) {
							sensorFromCopy = sensors[sensorToCopyIndex];
						} else {
							sensorFromCopy = sensors.find((sensor, sensorIndex) => sensor.location === sensorToCopy.location
								&& sensorIndex === sensorToCopyIndex);
						}

						if (sensorFromCopy != null) {
							if (!this.disableSerialNumLabel()) {
								sensorToCopy.serialNum = sensorFromCopy.serialNum;
								sensorToCopy.equipmentName = sensorFromCopy.equipmentName;
							}

							if (!this.disableUploadPhotoButton()) {
								sensorToCopy.idPhoto = sensorFromCopy.idPhoto;
							}

							this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex].sensors[sensorToCopyIndex] = sensorToCopy;

						}
					});

				});
			});

			this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.copySensors.ok') as string);
		}
	}

	showDialogDefrost(): void {
		const essay = this.dataSource.executionQTestEssayGroup[this._essayIndex];
		const essayValue = essay.essayValues[this._variableIndex];

		let values: SensorData[] = [];
		if (essayValue.sensors) {
			essayValue.sensors.filter(sensor => sensor.data != null && sensor.data.length !== 0)
				.forEach(sensor => values = [...values, ...sensor.data]);
		}

		const initDate = this.graph.minDate as Date;
		const endDate = this.graph.maxDate as Date;

		if (this.graph.isFixedRange() && values) {
			values = values.filter(item => item.date > initDate && item.date < endDate);
		}

		const dialogRef = this.dialog.open(ExecutionQEditDefrostListComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idEssay: essay.id,
				data: values,
				essayType: essay.idEssayType
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.defrostService.findAllFromEssay(essay.id).pipe(takeUntil(this.destroy$)).subscribe((item: Defrost[]) => {
				item.forEach(i => {
					i.startDate = DateUtils.anyToDate(i.startDate);
					i.endDate = DateUtils.anyToDate(i.endDate);
				});

				if (this.graph) {
					this.graph.defrosts = item;
					this.graph.recalculateData();
				}
			}, () => {
				this.graph?.recalculateData();
			});
		});

	}

	disableDefrostsButton(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		const notAllowedStatuses = [TestTypeEnum.TEST_BOWIE_DICK];

		if (this.data.data.idTestType != TestTypeEnum.TEST_BOWIE_DICK) {
			return !allowedStatuses.includes(this.data.idStatus);
		} else {
			return true;
		}
	}

	public showRestartGraph(): boolean {
		if (!this.graph) {
			return false;
		}

		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		if (this.data.data.idTestType != TestTypeEnum.TEST_BOWIE_DICK) {
			return this.graph.isFixedRange() && allowedStatuses.includes(this.data.idStatus);
		} else {
			return true;
		}
	}

	public restartGraph(): void {
		this.graph.idTypeEssay = this.dataSource.executionQTestEssayGroup[this._essayIndex].idEssayType;
		this.graph.restartGraph();
	}

	getIdTypeEssayCurrent(): number {
		return this.dataSource.executionQTestEssayGroup[this._essayIndex].idEssayType;
	}

	reloadGraphMap(): void {
		this.graphMap = new Map<string, SensorData[]>();

		this.dataSource.executionQTestEssayGroup?.forEach((essay, essayIndex) => {
			essay.essayValues.forEach((essayValue, variableIndex) => {
				let values: SensorData[] = [];
				essayValue.sensors.filter(sensor => sensor.data != null && sensor.data.length !== 0)
					.forEach(sensor => values = [...values, ...sensor.data]);

				essayValue.sensors.forEach(sensor => {
					this.equipmentAutoComplete.set(sensor.id, []);
				});

				if (values.length > 0) {
					const key = new EventEssayVariableKeys();
					key.essayIndex = essay.id;
					key.variableIndex = essayValue.idVariable;

					this.graphMap.set(key.toString(), values);
				}

				if (variableIndex !== 0) {
					const ek = new EventEssayVariableKeys();
					ek.essayIndex = essayIndex;
					ek.variableIndex = variableIndex;

					this.copyGraphDateMap.set(ek, true);
				}

			});
		});

		if (this.data.data.idTestType != TestTypeEnum.TEST_BOWIE_DICK) {
			this.updateGraphByIndex(this._essayIndex, this._variableIndex, false);
		}
	}

	displayEssay(): boolean {
		if (this.dataSource.executionQTestEssayGroup == null || ArrayUtils.isEmpty(this.dataSource.executionQTestEssayGroup) || this._essayIndex === null) {
			return false;
		}

		if (!this.graph) {
			window.setTimeout(() => {
				this.cd.detectChanges();
				this.updateGraphByIndex(this._essayIndex, this._variableIndex, false);
			});
		}

		return this.dataSource.executionQTestEssayGroup[this._essayIndex].active;
	}

	onFcStartEssayEmit(
		event: { essayIndex: number, variableIndex: number, fcStartEssay: Date, fcEndEssay: Date, changeTimezone: boolean }): void {
		this.fcStartEssayEmitter.next(event);

		const init = _.cloneDeep(event.fcStartEssay);
		const end = _.cloneDeep(event.fcEndEssay);

		if (event.essayIndex != null && event.variableIndex != null) {
			this.dataSource.executionQTestEssayGroup[event.essayIndex].essayValues[event.variableIndex].fcStartEssay = init;
			this.dataSource.executionQTestEssayGroup[event.essayIndex].essayValues[event.variableIndex].fcEndEssay = end;
			this.dataSource.executionQTestEssayGroup[event.essayIndex].essayValues[event.variableIndex].changeEssayDate = true;

			if (!this.graph.showCopyDateFirstSensor()) {
				this.copyGraphDateMap.forEach((value: boolean, key: EventEssayVariableKeys) => {
					if (key.essayIndex === event.essayIndex && key.variableIndex !== event.variableIndex && value) {
						this.dataSource.executionQTestEssayGroup[key.essayIndex].essayValues[key.variableIndex].fcStartEssay = init;
						this.dataSource.executionQTestEssayGroup[key.essayIndex].essayValues[key.variableIndex].fcEndEssay = end;
						this.dataSource.executionQTestEssayGroup[key.essayIndex].essayValues[key.variableIndex].changeEssayDate = true;
					}
				});
			}
		}
	}

	onCopyTimeGraphChange(event: { essayIndex: number, variableIndex: number, value: boolean }): void {
		const essayIndex = event.essayIndex;
		const variableIndex = event.variableIndex;
		const value = event.value;

		const ek = new EventEssayVariableKeys();
		ek.essayIndex = essayIndex;
		ek.variableIndex = variableIndex;

		this.copyGraphDateMap.set(ek, value);
	}

	onHotColdSpotChange(event: any): void {
		if (event.essayIndex != null && event.variableIndex != null) {
			const sensors = this.dataSource.executionQTestEssayGroup[event.essayIndex].essayValues[event.variableIndex].sensors;

			const sensor = sensors.find(s => s.equipmentName === event.equipmentName);

			if (sensor != null) {
				sensor.hotColdSpot = event.value as boolean;
			}
		}
	}

	onIdPeakChange(event: any): void {
		this.onIdPeakEmitter.next(event);
	}

	updateGraphByIndex(essayIndex: number, variableIndex: number, automatic: boolean): void {
		if (!this.graph || this.graph == null || ArrayUtils.isEmpty(this.dataSource.executionQTestEssayGroup)) {
			return;
		}

		const essaySelected = this.dataSource.executionQTestEssayGroup[essayIndex];
		const variableSelected = essaySelected.essayValues[variableIndex];

		this.graph.reasonModifyExpositionTime = variableSelected.reasonModifyExpositionTime;
		this.graph.essayIndex = essayIndex;
		this.graph.variableIndex = variableIndex;
		this.graph.idEssay = essaySelected.id;
		this.graph.idTypeEssay = essaySelected.idEssayType;
		this.graph.idVariable = variableSelected.id;
		this.graph.idTypeVariable = variableSelected.idVariable;
		this.graph.idUnit = variableSelected.idUnit;
		this.graph.idPeak = essaySelected.idPeakEventType;
		this.graph.idStatus = this.data.idStatus;

		this.graph.fcStartEssay = variableSelected.fcStartEssay as Date;
		this.graph.fcEndEssay = variableSelected.fcEndEssay as Date;

		this.graph.originalSensors = variableSelected.sensors;

		this.graph.verificationAutomatic = automatic;

		this.executionQTestEssayService.getLethalityValue(variableSelected).subscribe((res: LethalityValueEssay[]) => {

			res.forEach(lethal => {
				lethal.outer = variableSelected.sensors.find(s => s.serialNum === lethal.serialNum)?.outer;
			});

			this.graph.lethalityValue = res;
		});

		this.graph.hotColdSpotValue = new HotColdValueEssay();
		this.executionQTestEssayService.getHotColdSpotValue(variableSelected).subscribe((res: HotColdValueEssay) => {
			this.graph.hotColdSpotValue = res;
		});

		void this.calculateMinMax(variableSelected).then(minMax => this.graph.minMaxValue = minMax);
		void this.checkEssayDiffErrors(variableSelected.id).then(rSensor => this.graph.avgSensors = rSensor);
		void this.checkEssayDiffAveragesErrors(variableSelected.id).then(rSensor => this.graph.diffAvarages = rSensor);
		void this.checkDiffCalculateProbeWithRespectMeanErrors(variableSelected.id).then(rSensor => this.graph.diffProbeRespectAvg = rSensor);

		this.graph.criterias = variableSelected.criterias;
		/* void this.calculateDiff(variableSelected).then(res => {
		  this.graph.diffAvgValue = res;
		  console.log(res);
		}); */

		this.graph.changeTimezone = false;

		this.graph.showMkt = variableSelected.criterias.some(c => c.showMkt);

		// Buscamos en la variable seleccionada
		let rehearsalTime = variableSelected.fields?.find(item => item.idField === FieldEnum.REHEARSAL_TIME);

		// Si la variable seleccionada no tiene, buscamos en todo el ensayo
		if (rehearsalTime == null) {

			essaySelected.essayValues.forEach(essayValues => {
				if (rehearsalTime == null) {
					rehearsalTime = essayValues.fields?.find(item => item.idField === FieldEnum.REHEARSAL_TIME);
				}
			});
		}

		if (rehearsalTime != null) {
			this.graph.range = (rehearsalTime.value as string).toString();
			this.graph.fullEssay = false;
		} else {
			this.graph.fullEssay = true;
		}

		if (variableIndex !== 0) {
			const value = this.getValueFromCopyGraphDateMap(essayIndex, variableIndex);

			this.graph.copyDateFirstSensor = value;
		}

		const key = new EventEssayVariableKeys();
		key.essayIndex = essaySelected.id;
		key.variableIndex = variableSelected.idVariable;

		let data = this.graphMap.get(key.toString());

		if (!data) {
			let mapValue: SensorData[] = [];
			variableSelected.sensors.filter(sen => sen.data != null && sen.data.length !== 0).forEach(sen => {
				mapValue = [...mapValue, ...sen.data];
			});

			this.graphMap.set(key.toString(), mapValue);

			data = this.graphMap.get(key.toString());
		}

		if (variableSelected.fcStartEssay == null) {

			if (data != null && data.length !== 0) {
				let dates: Date[] = data.map(d => d.date);

				dates = dates.map(date => new Date(date)).filter((date, i, arr) =>
					arr.findIndex(d => d.getTime() === date.getTime()) === i).sort((d1, d2) => d1.getTime() - d2.getTime());
				const minDate = dates[0];
				variableSelected.fcStartEssay = minDate;
				this.onFcStartEssayEmit({
					essayIndex,
					variableIndex,
					fcStartEssay: variableSelected.fcStartEssay as Date,
					fcEndEssay: variableSelected.fcEndEssay as Date,
					changeTimezone: false
				});
			}
		}

		this.defrostService.findAllFromEssay(this.dataSource.executionQTestEssayGroup[essayIndex].id).pipe(takeUntil(this.destroy$)).subscribe((item: Defrost[]) => {
			item.forEach(i => {
				i.startDate = DateUtils.anyToDate(i.startDate);
				i.endDate = DateUtils.anyToDate(i.endDate);
			});

			this.graph.defrosts = item;
			this.graph.data = data;
		}, () => {
			this.graph.defrosts = [];
			this.graph.data = data;
		});

		this.variableUnits = [];

		if (variableSelected != null && variableSelected.idVariable != null) {
			this.variableTypeService.findUnits(variableSelected.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
				this.variableUnits = res;

				if (variableSelected.idUnit == null || !this.variableUnits.map(v => v.id).includes(variableSelected.idUnit)) {
					this.onUnitChange(this._variableIndex, res[0]);
				}
			});
		}
		this.graph.recalculateDateFilterOnChangeTab();
	}

	updateDataMultiple(indexGroup: number, indexItem: number, indexVerification: number, indexMultiple: number, data: ExecutionQTestData) {
		const errores = this.errorsDataMultiple(data);
		if (errores.length > 0) {
			const error = errores.join('\n');
			this.snackBarService.sendError(error);
		} else {
			if (data.regUser != null) {
				this.requestReason((reason) => {
					if (reason) {
						this.requestSign((token) => {
							this.spinnerService.show();
							data.reasonChange = reason;
							this.executionQTestDataMultipleService.updateDataMultiple(this.data.data.idExecution, this.data.data.id, data).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
								this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((itemObs: ExecutionQTestDataObservations[]) => {
									this.dataSource.executionQTestDataObservations = itemObs;
									this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[indexVerification].executionQTestDataMultiple[indexMultiple] = item;
									this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
									this.validateSaveMultiple();
									this.obsTestTable.renderRows();
									this.spinnerService.hide();
								}, error => {
									console.log(error);
									this.spinnerService.hide();
								});
								this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dataMultiple.form.ok') as string);
							}, error => {
								console.log(error);
								this.spinnerService.hide();

								this.snackBarService.sendError(this.translate.instant('executionEdit.dataMultiple.form.error') as string);
							});
						})
					}

				});
			} else {
				this.spinnerService.show();
				this.requestSign((token) => {
					this.executionQTestDataMultipleService.updateDataMultiple(this.data.data.idExecution, this.data.data.id, data).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
						this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((itemObs: ExecutionQTestDataObservations[]) => {
							this.dataSource.executionQTestDataObservations = itemObs;
							this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[indexVerification].executionQTestDataMultiple[indexMultiple] = item;
							this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
							this.validateSaveMultiple();
							this.obsTestTable.renderRows();
							this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dataMultiple.form.ok') as string);
							this.spinnerService.hide();
						}, error => {
							console.log(error);
							this.spinnerService.hide();
						});
					}, error => {
						console.log(error);
						this.spinnerService.hide();

						this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dataMultiple.form.error') as string);
					});
				});
			}
		}
	}

	errorsDataMultiple(data: ExecutionQTestData): string[] {
		const errors = [];
		if (!data.onlyLine) {
			if (!data.obtainedResult) {
				errors.push(this.translate.instant(this.translate.instant('executionTest.verificationType.obtainedResult.error')));
			}
		} else {
			if (!data.expectedResultDesc) {
				errors.push(this.translate.instant(this.translate.instant('executionTest.verificationType.expectedResult.error')));
			}
		}

		if (!data.selectedResult) {
			errors.push(this.translate.instant(this.translate.instant('executionTest.verificationType.selectedResult.error')));
		} else if (data.selectedResult === 'not_according') {
			if (!data.uuidDeviation || data.uuidDeviation?.length === 0) {
				errors.push(this.translate.instant('executionTest.deviation.resultDesc.empty'));
			}
		} else if (data.selectedResult === 'not_applicable') {
			if (!data.reasonChangeNoApplicable || StringUtils.isEmpty(data.reasonChangeNoApplicable)) {
				errors.push(this.translate.instant('executionTest.not_applicable.reason.empty'));
			}
		}

		return errors;
	}

	openCreateDialogTestObservations(btnCancel: boolean = false) {
		let maxPosition = this.dataSource.executionQTestDataObservations != null ? this.dataSource.executionQTestDataObservations.map(item => item.position).filter(position => position !== null && position !== undefined).reduce((max, current) => (current > max ? current : max), 0) : 0;

		let data = new ExecutionQTestDataObservations();
		if (btnCancel) {
			data.notSelectedTest = true;
		} else {
			data.notSelectedTest = false;
		}
		const dialogRef = this.dialog.open(ExecutionEditQTestObservationsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				data,
				position: maxPosition + 1,
				idExecutionTest: this.data.data.id,
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
			if (result) {
				this.spinnerService.show();
				this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
					this.dataSource.executionQTestDataObservations = item;
					this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
					this.obsTestTable.renderRows();
					this.spinnerService.hide();

				}, error => {
					console.log(error);
					this.spinnerService.show();
				});
			} else {
				if (btnCancel) {
					this.dialogRef.close();
				}

			}
		});
	}

	openEditDialogTestObservations(item: ExecutionQTestDataObservations) {
		const dialogRef = this.dialog.open(ExecutionEditQTestObservationsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				data: item,
				isEdit: true,
				idExecutionTest: this.data.data.id
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
			if (result) {
				this.spinnerService.show();
				this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
					this.dataSource.executionQTestDataObservations = item;
					this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
					this.obsTestTable.renderRows();
					this.spinnerService.hide();

				}, error => {
					console.log(error);
					this.spinnerService.hide();
				});
			}
		});
	}

	deleteTestObservations(obs: ExecutionQTestDataObservations) {
		const message = this.translate.instant('executionEditQ.form.obs.delete.confirm');
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
			if (result === true) {
				this.spinnerService.show();

				this.executionQTestDataObservationsService.delete(obs.id).pipe(takeUntil(this.destroy$)).subscribe((item: boolean[]) => {
					this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.obs.delete.ok'));
					this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
						this.dataSource.executionQTestDataObservations = item;

						for (let index = 0; index < this.dataSource.executionQTestItemGroup?.length; index++) {
							const element = this.dataSource.executionQTestItemGroup[index];
							for (let indexTestItem = 0; indexTestItem < element.executionQTestItems?.length; indexTestItem++) {
								const elementTestItem = element.executionQTestItems[indexTestItem];
								for (let indexItemVerification = 0; indexItemVerification < elementTestItem.executionQTestItemVerification?.length; indexItemVerification++) {
									const elementItemVerification = elementTestItem.executionQTestItemVerification[indexItemVerification];

									for (let indexDataMultiple = 0; indexDataMultiple < elementItemVerification.executionQTestDataMultiple?.length; indexDataMultiple++) {
										const elementDataMultiple = elementItemVerification.executionQTestDataMultiple[indexDataMultiple];
										elementDataMultiple.observations = elementDataMultiple.observations.filter(edo => edo !== obs.uuid);
									}
								}
							}
						}
						this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
						this.obsTestTable.renderRows();
						this.spinnerService.hide();

					}, error => {
						console.log(error);
						this.spinnerService.hide();
					});
				}, error => {
					console.log(error);
					this.spinnerService.hide();
				});
			}
		});

	}

	openEditSensor(essayIndex: number, variableIndex: number, sensorIndex: number): void {
		const sensor = this.getSensor(essayIndex, variableIndex, sensorIndex);

		const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];

		const isLastSensor = variableSelected.sensors.filter(s => s.id !== sensor.id && s.evaluate).length < 1;

		const dialogRef = this.dialog.open(ExecutionQEditConfigSensorComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				sensor: _.cloneDeep(sensor),
				isLastSensor
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Sensor) => {
			if (result != null) {
				this.setSensor(essayIndex, variableIndex, sensorIndex, result);

				variableSelected.sensors[sensorIndex] = result;

				this.graph.originalSensors = variableSelected.sensors;
				this.graph.verificationAutomatic = true;
				this.updateSensorDependency(essayIndex, variableIndex, sensorIndex, 'config');
				this.graph.recalculateGraph();
			}
		});

	}

	openCreateDialogInstrumentalUsed() {
		const dialogRef = this.dialog.open(ExecutionQEditTestInstrumentalUsedComponent, {
			minWidth: '70%',
			maxHeight: '95vh',
			data: {
				data: new ExecutionQTestInstrumentalUsed(),
				idExecutionTest: this.data.data.id,
				idStatus: this.data.idStatus
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestInstrumentalUsed) => {
			if (result) {
				if (!this.dataSource.executionQTestInstrumentalUsed) {
					this.dataSource.executionQTestInstrumentalUsed = [];
				}
				this.dataSource.executionQTestInstrumentalUsed.push(result);
				this.executionQTestInstrumentalUsedTable.renderRows();

			}
		});
	}

	openEditDialogInstrumentalUsed(index: number, item: ExecutionQTestInstrumentalUsed) {
		const dialogRef = this.dialog.open(ExecutionQEditTestInstrumentalUsedComponent, {
			minWidth: '70%',
			maxHeight: '95vh',
			data: {
				data: item,
				isEdit: true,
				idExecutionTest: this.data.data.id,
				idStatus: this.data.idStatus
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestInstrumentalUsed) => {
			if (result) {
				this.dataSource.executionQTestInstrumentalUsed[index] = result;
				this.executionQTestInstrumentalUsedTable.renderRows();
			}
		});
	}

	deleteInstrumentalUsed(index: number) {
		this.dataSource.executionQTestInstrumentalUsed.splice(index, 1);
		this.executionQTestInstrumentalUsedTable.renderRows();
	}

	get criticalInstrCols(): string[] {
		const res = [...this.criticalInstrumentalCols, 'maker', 'model', 'serialNum', 'existsEvidence', 'obs', 'according'];

		const validStatuses = [ExecutionStatus.EN_EJECUCION, ExecutionStatus.PENDIENTE_FIRMA];

		if (validStatuses.includes(this.data.idStatus)) {
			res.push('uploadCert');
		}

		if (this.enableEditCriticalInstrumentation()) {
			res.push('edit', 'delete', 'deviation', 'save');
		}

		return res;
	}

	enableEditCriticalInstrumentation(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus);
	}

	openNewCriticalInstrumentation(): void {
		const dialogRef = this.dialog.open(ExecutionQEditTestCriticalInstrumentationComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				criticalInstr: new ExecutionQTestCriticalInstrumentation()
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestCriticalInstrumentation) => {
			if (result != null) {
				if (!this.dataSource.executionQTestCriticalInstrumentation) {
					this.dataSource.executionQTestCriticalInstrumentation = [];
				}
				this.dataSource.executionQTestCriticalInstrumentation.push(result);
				this.renderCriticalInstrTable();
			}
		});
	}

	openEditCriticalInstrumentation(criticalInstrIndex: number): void {
		const crit = this.dataSource.executionQTestCriticalInstrumentation[criticalInstrIndex];

		const dialogRef = this.dialog.open(ExecutionQEditTestCriticalInstrumentationComponent, {
			minWidth: '50%',
			maxHeight: '95vh',
			data: {
				criticalInstr: _.cloneDeep(crit)
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestCriticalInstrumentation) => {

			if (result != null) {
				this.dataSource.executionQTestCriticalInstrumentation[criticalInstrIndex] = result;
				this.renderCriticalInstrTable();
			}
		});
	}

	disableUploadCriticalInstrumentationButton(): boolean {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION, ExecutionStatus.PENDIENTE_FIRMA];

		return !allowedStatuses.includes(this.data.idStatus);
	}

	styleUploadCriticalInstrumentationButton(item: ExecutionQTestCriticalInstrumentation): string {
		return (!this.disableUploadCriticalInstrumentationButton() && item.idCertificate != null) ? 'blueIcon' : '';

	}

	uploadCertificateCriticalInstrumentation(crit: ExecutionQTestCriticalInstrumentation, event): void {
		const file = event.target.files[0] as File;

		this.spinnerService.show();
		this.attachmentService.uploadCertificateToCriticalInstrumentation(crit.id, file).pipe(takeUntil(this.destroy$))
			.subscribe((res: number) => {
				this.dataSource.executionQTestCriticalInstrumentation.filter(item => item.id === crit.id).forEach(item => item.idCertificate = res);

				this.spinnerService.hide();

				this.snackBarService.sendSuccess(this.translate.instant('executionEdit.form.uploadCertificate.ok') as string);
			}, () => {
				this.spinnerService.hide();

				this.snackBarService.sendError(this.translate.instant('executionEdit.form.uploadCertificate.error') as string);
			});
	}

	removeCriticalInstrumentation(criticalInstrIndex: number): void {
		const cInst = this.dataSource.executionQTestCriticalInstrumentation[criticalInstrIndex];
		if (cInst != null) {
			this.requestReason((reason) => {
				//this.execution.reason = reason;
				this.dataSource.executionQTestCriticalInstrumentation.splice(criticalInstrIndex, 1);
				this.renderCriticalInstrTable();
			});
		} else {
			this.dataSource.executionQTestCriticalInstrumentation.splice(criticalInstrIndex, 1);
			this.renderCriticalInstrTable();
		}
	}

	showBowieDick() {
		return this.data.data.idTestType === TestTypeEnum.TEST_BOWIE_DICK;
	}

	validateTest() {
		this.requestSign((token) => {
			this.spinnerService.show();
			this.executionQTestService.validateTest(this.data.data.id, token).pipe(takeUntil(this.destroy$)).subscribe((exTest: ExecutionQTest) => {
				this.spinnerService.hide();
				this.snackBarService.sendSuccess(this.translate.instant('executionEdit.test.validate.ok') as string);
				this.dialogRef.close(exTest);
			}, error => {
				this.snackBarService.sendSuccess(this.translate.instant('executionEdit.test.validate.error') as string);
				console.log(error);
				this.spinnerService.hide();
			});
		})
	}

	showValidate() {
		const allowedStatuses = [ExecutionStatus.PENDIENTE_FIRMA];
		if (this.data.ex && this.data.ex?.regUser === this.currentUser.username) {
			return false;
		}
		return allowedStatuses.includes(this.data.idStatus) && !this.dataSource.validatedUser;
	}

	showInExecution() {
		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];
		return allowedStatuses.includes(this.data.idStatus);
	}

	saveEssay(indexEssay: number) {
		const essayGroup = this.dataSource.executionQTestEssayGroup[indexEssay]
		const errors = this.errorsEssay();

		if (errors.length === 0) {
			const devField = essayGroup.essayValues.some(ev => ev.fields.some(ef => ef.changedData && ef.showDiffInDeviations));
			if (devField) {
				// Aqui va el listado de las desviaciones que se van crear
			} else {
				this.spinnerService.show();

				this.executionQTestEssayGroupService.updateEssay(essayGroup.id, essayGroup).pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestEssayGroup) => {
					this.spinnerService.hide();
					this.snackBarService.sendSuccess(this.translate.instant("executionEdit.test.essay.save.ok"))
					this.dataSource.executionQTestEssayGroup[indexEssay] = result;

					result.essayValues.forEach(fe => {


						/*if (elementVerification.processingType === VerificationProcessingTypeEnum.BIOINDICATOR) {
							if (fe.bioindicatorsConfig) {
								if (fe.bioindicatorsConfig?.valid) {

								} else {

								}	
							}
							
						}

						if (elementVerification.processingType === VerificationProcessingTypeEnum.ENDOTOXIN) {
							if (fe.endotoxinsConfig) {
								if (fe.endotoxinsConfig?.valid) {

								} else {

								}	
							}
						}

						if (elementVerification.processingType === VerificationProcessingTypeEnum.PROBES_CORRECTLY) {
						}*/
					})

				}, error => {
					this.snackBarService.sendError(this.translate.instant("executionEdit.test.essay.save.error"))
					console.log(error);
					this.spinnerService.hide();
				});
			}
		} else {
			this.snackBarService.sendError(errors.join('\n'));
			return;
		}
	}

	errorsEssay(): string[] {
		let errors = [];

		for (let index = 0; index < this.dataSource.executionQTestEssayGroup.length; index++) {
			const element = this.dataSource.executionQTestEssayGroup[index];

			if (!element.active && !element.reasonActive) {
				errors.push(this.translate.instant('executionQEdit.test.essay.active.reason', { essay: this.translate.instant('essayType.' + element.translationType) }))
			}
		}

		return errors;

	}

	onPanelOpened(): boolean {
		return true;
	}

	devIsClose(indexGroup: number, indexItem: number, idxVerification: number, idxMultuple: number): boolean {
		const resSelected = this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple];

		if (resSelected.executionQTestDeviations || resSelected.executionQTestDeviations?.length > 0) {
			const continueQ = resSelected.executionQTestDeviations?.some(e => e.executionQTestDeviationData?.find(e => e.idType === TestTypeDeviations.VALUATION && (e.qualificationContinue === null || !e.qualificationContinue)));

			const closeData = resSelected.executionQTestDeviations?.some(e => e.executionQTestDeviationData?.find(e => e.idType === TestTypeDeviations.DEVIATION_RESOLUTION && e.resolved));
			if (closeData) {
				return closeData && !continueQ;
			} else {
				return false;
			}
		} else {
			return false;
		}

	}

	onSelectedCriticalResult(event: MatSelectChange, indexC: number) {
		const resSelected = this.dataSource.executionQTestCriticalInstrumentation[indexC];
		if (event?.value === 'not_according') {
			const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					protocolNumber: this.data.protocolNumber,
					deviation: _.cloneDeep(this.data.deviations?.filter(df => resSelected?.uuidDeviation?.includes(df.uuid))),
					idStatus: this.data.idStatus,
					idExecution: this.data.data.idExecution,
					idExecutionTest: this.data.data.id,
					isEditList: false,
				}
			});

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
				if (result) {
					if (this.data.deviations && this.data.deviations?.length > 0) {
						this.data.deviations.push(result);
					}
					if (result.observation) {
						this.dataSource.executionQTestDataObservations.push(result.observation);
						if (!this.dataSource.executionQTestCriticalInstrumentation[indexC].observations) {
							this.dataSource.executionQTestCriticalInstrumentation[indexC].observations = [];
						}

						this.dataSource.executionQTestCriticalInstrumentation[indexC].observations.push(result.uuidObs);
						this.obsTestTable.renderRows();
					}
					if (!this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation) {
						this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation = [];
					}
					this.dataSource.executionQTestCriticalInstrumentation[indexC].save = false;
					this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation.push(result.uuid);

					this.devTable.renderRows();
				}
			});
		} else if (event?.value === 'not_applicable') {
			if (this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation) {
				this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation = null;
				this.dataSource.executionQTestCriticalInstrumentation[indexC].save = false;
			}
			this.requestReason((reason) => {
				if (reason) {
					const position = this.dataSource.executionQTestDataObservations ? this.dataSource.executionQTestDataObservations?.length : 0;
					const obs = new ExecutionQTestDataObservations();
					obs.idExecutionTest = this.data.data.id;
					obs.description = reason;
					obs.position = position + 1;
					this.spinnerService.show();

					this.executionQTestDataObservationsService.save(obs).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDataObservations) => {
						this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
							this.dataSource.executionQTestDataObservations = item;
							if (this.dataSource.executionQTestDataObservations) {
								this.dataSource.executionQTestDataObservations.sort((a, b) => a.position - b.position);
							}
							this.obsTestTable.renderRows();
							this.spinnerService.hide();
						}, error => {
							console.log(error);
							this.spinnerService.show();
						});
					});
				} else {
					this.dataSource.executionQTestCriticalInstrumentation[indexC].selectedResult = null
				}
			});
		} else {
			const dataDev = this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation;
			if (dataDev) {
				const dataDevResolution = this.data.deviations?.filter(ddt => dataDev.includes(ddt.uuid));
				if (dataDevResolution) {
					const devResolved = dataDevResolution.some(dvr => dvr.executionQTestDeviationData.some(e => e.idType === TestTypeDeviations.DEVIATION_RESOLUTION && e.resolved));
					if (devResolved) {
						const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
							data: {
								message: this.translate.instant('executionEdit.deviation.change.result') as string
							}
						});
						dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
							if (result === true) {
								this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation = null;
								this.dataSource.executionQTestCriticalInstrumentation[indexC].save = false;
							}
						});
					} else {
						this.dataSource.executionQTestCriticalInstrumentation[indexC].uuidDeviation = null;
						this.dataSource.executionQTestCriticalInstrumentation[indexC].save = false;
					}
				}
			}
		}
	}

	updateCritical(indexC: number, data: ExecutionQTestCriticalInstrumentation) {
		const errores = [];
		if (errores.length > 0) {
			const error = errores.join('\n');
			this.snackBarService.sendError(error);
		} else {
			if (data.modFc != null) {
				this.requestReason((reason) => {
					this.requestSign((token) => {
						this.spinnerService.show();
						data.reasonChange = reason;
						this.executionQTestCriticalInstrumentationService.updateCritical(this.data.data.idExecution, this.data.data.id, data).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestCriticalInstrumentation) => {
							this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((itemObs: ExecutionQTestDataObservations[]) => {
								this.dataSource.executionQTestDataObservations = itemObs;
								this.dataSource.executionQTestCriticalInstrumentation[indexC] = item;
								this.validateCriticalInstrumental();
								this.obsTestTable.renderRows();
								this.spinnerService.hide();
							}, error => {
								console.log(error);
								this.spinnerService.hide();
							});
							this.snackBarService.sendSuccess(this.translate.instant('executionEdit.criticalInstr.form.ok') as string);
						}, error => {
							console.log(error);
							this.spinnerService.hide();

							this.snackBarService.sendError(this.translate.instant('executionEdit.criticalInstr.form.error') as string);
						});
					})

				});
			} else {
				this.spinnerService.show();
				this.requestSign((token) => {
					this.executionQTestCriticalInstrumentationService.updateCritical(this.data.data.idExecution, this.data.data.id, data).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestCriticalInstrumentation) => {
						this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((itemObs: ExecutionQTestDataObservations[]) => {
							this.dataSource.executionQTestDataObservations = itemObs;
							this.dataSource.executionQTestCriticalInstrumentation[indexC] = item;
							this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
							this.validateCriticalInstrumental();
							this.obsTestTable.renderRows();
							this.snackBarService.sendSuccess(this.translate.instant('executionEdit.criticalInstr.form.ok') as string);
							this.spinnerService.hide();
						}, error => {
							console.log(error);
							this.spinnerService.hide();
						});
					}, error => {
						console.log(error);
						this.spinnerService.hide();

						this.snackBarService.sendSuccess(this.translate.instant('executionEdit.criticalInstr.form.error') as string);
					});
				});
			}
		}
	}

	isAccording(value: ExecutionQTestDataOQ): string {
		const notApplicable = "not_applicable";

		if (value?.selectedResult === 'according') {
			return this.translate.instant("resultTypeSelected.according");
		} else if (value?.selectedResult === notApplicable) {
			return this.translate.instant("resultTypeSelected.not_applicable");
		}

		return this.translate.instant('resultTypeSelected.not_according');
	}

	onBlurObtainedResult(event: FocusEvent, indexGroup: number, indexItem: number, idxVerification: number, idxMultuple: number) {
		const inputValue = (event.target as HTMLInputElement).value;
		const textReview = this.itemGroupReserve[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple];

		if (textReview.regUser != null) {
			if (inputValue !== textReview?.obtainedResult) {
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].modUser = this.currentUser.username;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].modDate = new Date();
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].obtainedResult = inputValue;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].selectedResult = null;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = false;
			} else {
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].modUser = textReview.modUser;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].modDate = textReview.modDate;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].obtainedResult = textReview.obtainedResult;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].selectedResult = textReview.selectedResult;
				this.dataSource.executionQTestItemGroup[indexGroup].executionQTestItems[indexItem].executionQTestItemVerification[idxVerification].executionQTestDataMultiple[idxMultuple].save = true;
			}
		}
	}

	validateSaveMultiple() {
		if (this.dataSource.executionQTestItemGroup) {
			for (let index = 0; index < this.dataSource.executionQTestItemGroup?.length; index++) {
				const element = this.dataSource.executionQTestItemGroup[index];

				for (let indexItem = 0; indexItem < element.executionQTestItems?.length; indexItem++) {
					const elementItem = element.executionQTestItems[indexItem];

					for (let indexVerification = 0; indexVerification < elementItem.executionQTestItemVerification?.length; indexVerification++) {
						const elementVerification = elementItem.executionQTestItemVerification[indexVerification];

						for (let indexMultiple = 0; indexMultiple < elementVerification.executionQTestDataMultiple?.length; indexMultiple++) {
							const elementMultiple = elementVerification.executionQTestDataMultiple[indexMultiple];

							if (elementMultiple.regUser) {
								elementMultiple.save = true;
							}
						}
					}
				}
			}
		}
	}

	validateCriticalInstrumental() {
		if (this.dataSource.executionQTestCriticalInstrumentation) {
			for (let index = 0; index < this.dataSource.executionQTestCriticalInstrumentation?.length; index++) {
				const element = this.dataSource.executionQTestCriticalInstrumentation[index];
				if (element.regUser) {
					element.save = true;
					this.renderCriticalInstrTable();
				}
			}
		}
	}

	enableEditField(field: Field): boolean {
		if (!field.editableInExecution) {
			return false;
		}

		const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

		return allowedStatuses.includes(this.data.idStatus);
	}

	showDeviationSelectedIndividual(uuid: string) {
		const resSelected = this.data.deviations.find(ee => ee.uuid === uuid);
		const indexRes = this.data.deviations.findIndex(ee => ee.uuid === uuid)

		if (resSelected) {
			const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
				minWidth: '70%',
				maxHeight: '95vh',
				data: {
					deviation: _.cloneDeep(resSelected),
					isEditList: true,
					protocolNumber: this.data.protocolNumber,
					idStatus: this.data.idStatus,
					idExecution: this.data.data.idExecution,
					idExecutionTest: this.data.data.id
				}
			});

			dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
				if (result) {
					this.data.deviations[indexRes] = { ...result };

					this.devTable.renderRows();
				}
			});
		}
	}

	openCreateDialogDeviation() {
		const dialogRef = this.dialog.open(ExecutionEditQDeviationComponent, {
			minWidth: '70%',
			maxHeight: '95vh',
			data: {
				protocolNumber: this.data.protocolNumber,
				executionNumber: this.data.ex.documentCode,
				deviation: new ExecutionQTestDeviations(),
				idStatus: this.data.idStatus,
				idExecution: this.data.data.idExecution,
				idExecutionTest: this.data.data.id,
				isEditList: false
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQTestDeviations) => {
			if (result) {
				if (!this.data.deviations) {
					this.data.deviations = [];
				}
				if (result.observation) {
					this.dataSource.executionQTestDataObservations.push(result.observation);
					this.obsTestTable.renderRows();
				}

				this.data.deviations.push(result);
				this.devTable.renderRows();
			}
		});
	}

	disabledAccording(result: string) {
		return result !== 'not_according';
	}

	getValuationDeviation(deviation: ExecutionQTestDeviations) {
		const resValuation = deviation.executionQTestDeviationData.find(e => e.idType === 2);
		if (resValuation) {
			return resValuation.valuation === 1 ? this.translate.instant('valuation.critical') : resValuation.valuation === 2 ? this.translate.instant('valuation.mayor') : resValuation.valuation === 3 ? this.translate.instant('valuation.minor') : '';
		}
		return '';
	}

	getResolvedDeviation(deviation: ExecutionQTestDeviations) {
		const resValuation = deviation.executionQTestDeviationData.find(e => e.idType === 5);
		if (resValuation) {
			return resValuation.resolved ? this.translate.instant('common.yes') : this.translate.instant('common.no');
		} else {
			return this.translate.instant('common.no');
		}
	}

	onSelectedDeviation(event: MatSelectChange, data: ExecutionQTestData) {
		const selectedUuids: string[] = event.value || [];
		const previousUuids: string[] = data.uuidDeviation || [];

		data.selectExistDeviations ??= [];
		const newlySelectedUuids = selectedUuids.filter(uuid => !previousUuids.includes(uuid));
		const deselectedUuids = previousUuids.filter(uuid => !selectedUuids.includes(uuid));

		data.selectExistDeviations = data.selectExistDeviations?.filter(dev => !deselectedUuids?.includes(dev.uuid));

		for (let index = 0; index < newlySelectedUuids.length; index++) {
			const uuid = newlySelectedUuids[index];
			const deviation = this.data.deviations.find(dev => dev.uuid === uuid);

			if (deviation && deviation.idExecutionTest !== this.data.data.id && !data.selectExistDeviations.some(dev => dev.uuid === uuid)) {
				data.selectExistDeviations.push(deviation);
			}
		}

		data.uuidDeviation = selectedUuids;
	}

	onSelectedDeviationCritical(event: MatSelectChange, data: ExecutionQTestCriticalInstrumentation) {
		const selectedUuids: string[] = event.value || [];
		const previousUuids: string[] = data.uuidDeviation || [];

		data.selectExistDeviations ??= [];
		const newlySelectedUuids = selectedUuids.filter(uuid => !previousUuids.includes(uuid));
		const deselectedUuids = previousUuids.filter(uuid => !selectedUuids.includes(uuid));

		data.selectExistDeviations = data.selectExistDeviations?.filter(dev => !deselectedUuids?.includes(dev.uuid));

		for (let index = 0; index < newlySelectedUuids.length; index++) {
			const uuid = newlySelectedUuids[index];
			const deviation = this.data.deviations.find(dev => dev.uuid === uuid);

			if (deviation && deviation.idExecutionTest !== this.data.data.id && !data.selectExistDeviations.some(dev => dev.uuid === uuid)) {
				data.selectExistDeviations.push(deviation);
			}
		}

		data.uuidDeviation = selectedUuids;
	}

	saveDataOQ() {
		this.requestSign((token) => {
			this.spinnerService.show();
			this.dataSource.executionQTestOQVerification?.forEach(oq => {
				this.executionQTestDataOQService.updateDataOQ(this.data.data.id, oq).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDataOQ) => {
					this.executionQTestDataObservationsService.getAllByIdExecutionTest(this.dataSource.id).pipe(takeUntil(this.destroy$)).subscribe((itemObs: ExecutionQTestDataObservations[]) => {
						this.dataSource.executionQTestDataObservations = itemObs;
						const index = this.dataSource.executionQTestOQVerification.findIndex(e => e.id === res.id);
						if (index !== -1) {
							this.dataSource.executionQTestOQVerification[index] = res;
						}
						this.dataSource.executionQTestDataObservations?.sort((a, b) => a.position - b.position);
						this.obsTestTable.renderRows();
						this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dataMultiple.form.ok') as string);
						this.spinnerService.hide();
					}, error => {
						console.log(error);
						this.spinnerService.hide();
					});
				}, error => {
					console.log(error);
					this.spinnerService.hide();

					this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dataMultiple.form.error') as string);
				});
			});
		});
	}

	openDeleteSensor(essayIndex: number, variableIndex: number, sensorIndex: number): void {
		const message = this.translate.instant('executionEdit.essays.sensor.form.delete.message') as string;

		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			data: { message }
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
			if (result === true) {
				const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];
				variableSelected.sensors.splice(sensorIndex, 1);
				this.graph.originalSensors = variableSelected.sensors;
				this.graph.verificationAutomatic = true;
				this.graph.recalculateGraph();
			}
		});
	}

	openNewSensor(essayIndex: number, variableIndex: number): void {
		const variableSelected = this.dataSource.executionQTestEssayGroup[essayIndex].essayValues[variableIndex];

		const sensor = new Sensor();
		sensor.fromProtocol = false;
		sensor.idVariable = variableSelected.idVariable;
		sensor.evaluate = true;
		sensor.showDiffInDeviations = true;

		const dialogRef = this.dialog.open(ExecutionQEditConfigSensorComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				sensor,
				isLastSensor: false
			}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Sensor) => {
			if (result != null) {
				variableSelected.sensors.push(result);
				this.graph.originalSensors = variableSelected.sensors;
			}
		});
	}

	onGeneralPhotoUpload(essayIndex: number, event): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];

		const file = event.target.files[0] as File;

		this.spinnerService.show();

		PhotoUtils.fixImage(file, this.imageCompress, (res) => {
			this.attachmentService.uploadGeneralPhoto(this.data.data.id, essay.id, res).pipe(takeUntil(this.destroy$))
				.subscribe((item: number) => {
					this.dataSource.executionQTestEssayGroup[essayIndex].idPhoto = item;

					this.spinnerService.hide();

					this.snackBarService.sendSuccess(this.translate.instant('executionEdit.essays.form.uploadImage.ok') as string);
				}, () => {
					this.spinnerService.hide();

					this.snackBarService.sendError(this.translate.instant('executionEdit.essays.form.uploadImage.error.generic') as string);
				});
		});
	}

	openDialogGeneralPhoto(essayIndex: number): void {
		const essay = this.dataSource.executionQTestEssayGroup[essayIndex];

		this.dialog.open(ExecutionQEditAttachmentDetailsComponent, {
			minWidth: '40%',
			maxHeight: '95vh',
			data: {
				idExecutionTest: this.data.data.id,
				idSensor: essay.id,
				idAttachment: essay.idPhoto,
				accept: 'image/*',
				isPhoto: true,
				isEssay: true,
				disableUpload: this.disableUploadPhotoButton(),
				type: 'generalPhoto'
			}
		});
	}

	getMaxDateEssay(res: ExecutionQTest): Date {
		let maxDate = null;
		for (let i = 0; i < res.executionQTestEssayGroup?.length; i++) {
			const reig = res.executionQTestEssayGroup[i];

			for (let j = 0; j < reig.essayValues?.length; j++) {
				const reige = reig.essayValues[j];

				for (let k = 0; k < reige.sensors?.length; k++) {
					const reigev = reige.sensors[k];

					if (reigev && reigev?.data) {
						for (let l = 0; l < reigev.data?.length; l++) {
							const edm = reigev.data[l];
							const date = new Date(edm.date);

							if (!maxDate || date > maxDate) {
								maxDate = date;
							}
						}
					}

				}
			}
		}
		return maxDate;
	}

	async onValidateVerificationEssay(event: any): Promise<void> {
		const resEssayGroup = this.dataSource.executionQTestEssayGroup?.find(eg => eg.id === event.idEssay && eg.essayValues?.some(ev => ev.sensors?.some(es => es.data?.length > 0)));
		if (resEssayGroup) {
			const resItemGroup = this.dataSource.executionQTestItemGroup?.filter(eig => eig.uuid === resEssayGroup.uuid);
			if (resItemGroup && resItemGroup?.length > 0) {
				for (let indexGroup = 0; indexGroup < resItemGroup.length; indexGroup++) {
					const elementGroup = resItemGroup[indexGroup];
					for (let indexItem = 0; indexItem < elementGroup.executionQTestItems?.length; indexItem++) {
						const elementItem = elementGroup.executionQTestItems[indexItem];

						for (let indexVerification = 0; indexVerification < elementItem.executionQTestItemVerification?.length; indexVerification++) {
							const elementVerification = elementItem.executionQTestItemVerification[indexVerification];

							let resCriteria = [];
							let meetCriteria = null;
							let resMeetCriteria = null;
							if (elementVerification.processingType === VerificationProcessingTypeEnum.MEETS_CRITERIA) {
								if (ArrayUtils.isNotEmpty(event.noMeetsSensor)) {
									for (let index = 0; index < event.noMeetsSensor.length; index++) {
										const sensor = event.noMeetsSensor[index];
										resCriteria.push(this.translate.instant('execution.test.essay.criteria.sensor.valuation', { sensor: sensor.sensor, location: sensor.location }));
									}

									if (event.noMeetsSensor.length === 1) {
										meetCriteria = this.translate.instant('execution.test.essay.criteria.comply.thereOne');
									} else {
										meetCriteria = this.translate.instant('execution.test.essay.criteria.comply.thereMore');
									}
								}

								resMeetCriteria = this.translate.instant('execution.test.essay.criteria.sensor.text', { sensor: QualificationUtils.completePhraseWithAnd(resCriteria, this.translate), essayTitle: resEssayGroup.title ? resEssayGroup.title : this.translate.instant('essayType' + resEssayGroup.translationType), comply: meetCriteria });

								if (resEssayGroup.active && resEssayGroup.essayValues?.some(rev => rev.fcStartEssay && rev.fcEndEssay)) {
									const highestFrequency = resEssayGroup.essayValues?.[0]?.fields.find(field => field.idField === FieldEnum.REHEARSAL_TIME);

									if (highestFrequency?.value) {
										for (let index = 0; index < resEssayGroup.essayValues?.length; index++) {
											const element = resEssayGroup.essayValues[index];

											const validateExpositionTime = ProtocolUtils.validateExpositionTime(element.fcStartEssay, element.fcEndEssay, highestFrequency.value);
											if (!validateExpositionTime) {
												if (resMeetCriteria != null) {
													resMeetCriteria = " <p></p>";
												}
												resMeetCriteria = this.translate.instant('execution.test.essay.timeExpesure.invalid.text', { essayTitle: resEssayGroup.title });
											}
										}
									}
								}

								if (resMeetCriteria) {
									const devRes = this.dataSource.deviations?.find(deviation => {
										return deviation.processingType === elementVerification.processingType && elementVerification.executionQTestDataMultiple?.some(dm =>
											dm.uuidDeviation?.includes(deviation.uuid)
										);
									});

									if (devRes) {
										await this.deleteDeviation.call(this, this.data.ex.id, devRes.id);
									}

									const codeList = this.data.deviations?.map(ds => ds.codeDeviation);
									let dev = new ExecutionQTestDeviations();
									dev.codeDeviation = 'D-' + this.data.ex.documentCode + "-" + ProtocolUtils.getMaxNumberDeviation(codeList);
									dev.regDate = new Date();
									dev.regUser = 'qloud';
									dev.uuid = uuid();
									dev.executionQTestDeviationData = [];
									let devResolution = new ExecutionQTestDeviationData();
									devResolution.idType = TestTypeDeviations.COMMENTS;
									devResolution.comments = resMeetCriteria;
									dev.executionQTestDeviationData.push(devResolution);
									dev.processingType = VerificationProcessingTypeEnum.MEETS_CRITERIA;

									if (!this.dataSource.deviations) {
										this.dataSource.deviations = [];
									}
									this.dataSource.deviations.push(dev);

									dev.idExecutionTest = this.data.data.id;
									this.deviationService.updateDeviation(this.data.ex.id, this.data.data.id, dev).pipe(takeUntil(this.destroy$)).subscribe((resdata: ExecutionQTestDeviations) => {

										for (let indexMultiple = 0; indexMultiple < elementVerification.executionQTestDataMultiple.length; indexMultiple++) {
											const dm = elementVerification?.executionQTestDataMultiple[indexMultiple];
											dm.obtainedResult = this.translate.instant('common.no');
											dm.regUser = 'qloud';
											dm.regDate = this.getMaxDateEssay(this.dataSource);
											dm.selectedResult = 'not_according';

											if (!dm.uuidDeviation) {
												dm.uuidDeviation = [];
											}

											if (!dm.observations) {
												dm.observations = [];
											}

											dm.observations.push(resdata.uuidObs);
											dm.uuidDeviation.push(resdata.uuid);

											this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
												elementGroup.executionQTestItems[indexItem].executionQTestItemVerification[indexVerification].executionQTestDataMultiple[indexMultiple] = item;
											});
										}
									}, error => {
										this.spinnerService.hide();
										console.log(error);
									});
								} else {
									elementVerification.executionQTestDataMultiple.forEach(dm => {
										dm.obtainedResult = this.translate.instant('common.yes');
										dm.regUser = 'qloud';
										dm.regDate = this.getMaxDateEssay(this.dataSource);
										dm.selectedResult = 'according';
										this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
											dm = item;
										});
									});
								}
							}

							let completeOpenDoor;
							if (elementVerification.processingType === VerificationProcessingTypeEnum.COMPLETY_OPEN_DOOR) {
								if (event.eventValue) {
									if (!event.eventValue.timeEventDate) {
										const essayGroup = this.dataSource.executionQTestEssayGroup.find(eg => eg.id === event.idEssay)
										const resVariable = QualificationUtils.getVariablesExecutionEssayByGroupJoin(essayGroup, this.translate, false);

										if (essayGroup.essayValues.length === 1) {
											completeOpenDoor = this.translate.instant('execution.test.essay.openDoor.invalid.text.singular', { variable: resVariable });
										} else {
											completeOpenDoor = this.translate.instant('execution.test.essay.openDoor.invalid.text.plural', { variable: resVariable });
										}

										const devRes = this.dataSource.deviations?.find(deviation => {
											return deviation.processingType === elementVerification.processingType && elementVerification.executionQTestDataMultiple?.some(dm =>
												dm.uuidDeviation?.includes(deviation.uuid)
											);
										});

										if (devRes) {
											await this.deleteDeviation.call(this, this.data.ex.id, devRes.id);
										}

										const codeList = this.dataSource.deviations?.map(ds => ds.codeDeviation);
										let dev = new ExecutionQTestDeviations();
										dev.codeDeviation = 'D-' + this.data.ex.documentCode + "-" + ProtocolUtils.getMaxNumberDeviation(codeList);
										dev.regDate = new Date();
										dev.regUser = 'qloud';
										dev.uuid = uuid();
										dev.executionQTestDeviationData = [];
										let devResolution = new ExecutionQTestDeviationData();
										devResolution.idType = TestTypeDeviations.COMMENTS;
										devResolution.comments = meetCriteria;
										dev.processingType = VerificationProcessingTypeEnum.COMPLETY_OPEN_DOOR;
										dev.executionQTestDeviationData.push(devResolution);
										this.dataSource.deviations.push(dev);

										dev.idExecutionTest = this.data.data.id;
										this.deviationService.updateDeviation(this.data.ex.id, this.data.data.id, dev).pipe(takeUntil(this.destroy$)).subscribe((resdata: ExecutionQTestDeviations) => {
											elementVerification.executionQTestDataMultiple.forEach(dm => {
												dm.obtainedResult = this.translate.instant('common.no');
												dm.regUser = 'qloud';
												dm.regDate = this.getMaxDateEssay(this.dataSource);
												dm.selectedResult = 'not_according';

												if (!dm.uuidDeviation) {
													dm.uuidDeviation = [];
												}

												if (!dm.observations) {
													dm.observations = [];
												}

												dm.observations.push(resdata.uuidObs);
												dm.uuidDeviation.push(resdata.uuid);

												this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
													dm = item;
												});
											});
										}, error => {
											this.spinnerService.hide();
											console.log(error);
										});
									} else {
										elementVerification.executionQTestDataMultiple.forEach(dm => {
											dm.obtainedResult = this.translate.instant('common.yes');
											dm.regUser = 'qloud';
											dm.regDate = this.getMaxDateEssay(this.dataSource);
											dm.selectedResult = 'according';
											this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
												dm = item;
											});
										});
									}
								}
							}

							if (elementVerification.processingType === VerificationProcessingTypeEnum.COMPLETY_CUT_ELECTRIC) {
								if (event.eventValue) {
									if (!event.eventValue.timeEventDate) {
										const essayGroup = this.dataSource.executionQTestEssayGroup.find(eg => eg.id === event.idEssay)
										const resVariable = QualificationUtils.getVariablesExecutionEssayByGroupJoin(essayGroup, this.translate, false);

										if (essayGroup.essayValues.length === 1) {
											completeOpenDoor = this.translate.instant('execution.test.essay.openDoor.invalid.text.singular', { variable: resVariable });
										} else {
											completeOpenDoor = this.translate.instant('execution.test.essay.openDoor.invalid.text.plural', { variable: resVariable });
										}

										const devRes = this.dataSource.deviations?.find(deviation => {
											return deviation.processingType === elementVerification.processingType && elementVerification.executionQTestDataMultiple?.some(dm =>
												dm.uuidDeviation?.includes(deviation.uuid)
											);
										});

										if (devRes) {
											await this.deleteDeviation.call(this, this.data.ex.id, devRes.id);
										}

										const codeList = this.dataSource.deviations?.map(ds => ds.codeDeviation);
										let dev = new ExecutionQTestDeviations();
										dev.codeDeviation = 'D-' + this.data.ex.documentCode + "-" + ProtocolUtils.getMaxNumberDeviation(codeList);
										dev.regDate = new Date();
										dev.regUser = 'qloud';
										dev.uuid = uuid();
										dev.executionQTestDeviationData = [];
										let devResolution = new ExecutionQTestDeviationData();
										devResolution.idType = TestTypeDeviations.COMMENTS;
										devResolution.comments = meetCriteria;
										dev.processingType = VerificationProcessingTypeEnum.COMPLETY_CUT_ELECTRIC;
										dev.executionQTestDeviationData.push(devResolution);
										this.dataSource.deviations.push(dev);

										dev.idExecutionTest = this.data.data.id;
										this.deviationService.updateDeviation(this.data.ex.id, this.data.data.id, dev).pipe(takeUntil(this.destroy$)).subscribe((resdata: ExecutionQTestDeviations) => {
											elementVerification.executionQTestDataMultiple.forEach(dm => {
												dm.obtainedResult = this.translate.instant('common.no');
												dm.regUser = 'qloud';
												dm.regDate = this.getMaxDateEssay(this.dataSource);
												dm.selectedResult = 'not_according';

												if (!dm.uuidDeviation) {
													dm.uuidDeviation = [];
												}

												if (!dm.observations) {
													dm.observations = [];
												}

												dm.observations.push(resdata.uuidObs);
												dm.uuidDeviation.push(resdata.uuid);

												this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
													dm = item;
												});
											});
										}, error => {
											this.spinnerService.hide();
											console.log(error);
										});
									} else {
										elementVerification.executionQTestDataMultiple.forEach(dm => {
											dm.obtainedResult = this.translate.instant('common.yes');
											dm.regUser = 'qloud';
											dm.regDate = this.getMaxDateEssay(this.dataSource);
											dm.selectedResult = 'according';
											this.executionQTestDataMultipleService.updateDataMultiple(this.data.ex.id, elementGroup.idExecutionTest, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
												dm = item;
											});
										});
									}
								}
							}
						}
					}
				}
			}
		}
	}

	private async deleteDeviation(idExecution: number, idDeviation: number) {
		const res = await firstValueFrom(this.deviationService.deleteDeviation(idExecution, idDeviation));
		return res;
	}

	private renderCriticalInstrTable() {
		if (this.criticalInstrTable instanceof QueryList) {
			this.criticalInstrTable = this.criticalInstrTable.first as MatTable<any>;
		}

		this.criticalInstrTable.dataSource = this.dataSource.executionQTestCriticalInstrumentation;
		this.criticalInstrTable.renderRows();
	}

	private calculateMinMax(variableSelected: ExecutionQTestEssay): Promise<MinMaxValueEssay> {
		if (this.graph) {
			this.graph.minMaxValue = new MinMaxValueEssay();
		}

		return new Promise((resolve) => {
			this.executionQTestEssayService.getMinMaxValue(variableSelected).subscribe((res: MinMaxValueEssay) => {
				resolve(res);
			});
		});
	}

	// Diff between sonda
	private checkEssayDiffErrors(idEssay: number): Promise<string[]> {
		return new Promise((resolve) => {
			this.executionQTestEssayService.checkEssayDiffErrors(idEssay).subscribe((res: string[]) => {
				resolve(res);
			});
		});
	}

	private checkEssayDiffAveragesErrors(idEssay: number): Promise<string[]> {
		return new Promise((resolve) => {
			this.executionQTestEssayService.checkEssayDiffAveragesErrors(idEssay).subscribe((res: string[]) => {
				resolve(res);
			});
		});
	}

	// Diff. of each probe with respect to the mean
	private checkDiffCalculateProbeWithRespectMeanErrors(idEssay: number): Promise<string[]> {
		return new Promise((resolve) => {
			this.executionQTestEssayService.checkDiffCalculateProbeWithRespectMeanErrors(idEssay).subscribe((res: string[]) => {
				resolve(res);
			});
		});
	}

	private getValueFromCopyGraphDateMap(essayIndex: number, variableIndex: number): boolean {
		let res: boolean = null;

		this.copyGraphDateMap.forEach((value, key) => {
			if (key.essayIndex === essayIndex && key.variableIndex === variableIndex) {
				res = value;
				return;
			}
		});

		return res;
	}

	private requestSign(callback: (token: string) => void) {
		this.spinnerService.hide();

		const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
			minWidth: '20%',
			maxHeight: '95vh',
			data: {}
		});

		dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
			if (result != null) {
				callback(result);
			}
		});
	}
}